export const DictionaryIllustrator_de_DE = [
    {
        id: 18,
        label: 'Bearbeiten > Davor einfügen',
        placement: 'MenuBar',
        name: 'Davor einfügen',
    },
    {
        id: 19,
        label: 'Bearbeiten > Dahinter einfügen',
        placement: 'MenuBar',
        name: 'Dahinter einfügen',
    },
    {
        id: 20,
        label: 'Datei > Neu aus Vorlage...',
        placement: 'MenuBar',
        name: 'Neu aus Vorlage...',
    },
    {
        id: 22,
        label: 'Objekt > Transformieren > Erneut transformieren',
        placement: 'MenuBar',
        name: 'Erneut transformieren',
    },
    {
        id: 23,
        label: 'Objekt > Gruppieren',
        placement: 'MenuBar',
        name: 'Gruppieren',
    },
    {
        id: 24,
        label: 'Objekt > Gruppierung aufheben',
        placement: 'MenuBar',
        name: 'Gruppierung aufheben',
    },
    {
        id: 25,
        label: 'Objekt > Pfad > Zusammenfügen...',
        placement: 'MenuBar',
        name: 'Zusammenfügen...',
    },
    {
        id: 26,
        label: 'Objekt > Pfad > Durchschnitt berechnen...',
        placement: 'MenuBar',
        name: 'Durchschnitt berechnen...',
    },
    {
        id: 28,
        label: 'Objekt > Sperren > Auswahl',
        placement: 'MenuBar',
        name: 'Auswahl',
    },
    {
        id: 29,
        label: 'Objekt > Alle entsperren',
        placement: 'MenuBar',
        name: 'Alle entsperren',
    },
    {
        id: 30,
        label: 'Ansicht > Vorschau',
        placement: 'MenuBar',
        name: 'Vorschau',
    },
    {
        id: 33,
        label: 'Ansicht > Pixelvorschau',
        placement: 'MenuBar',
        name: 'Pixelvorschau',
    },
    {
        id: 34,
        label: 'Schrift > Flächentextoptionen...',
        placement: 'MenuBar',
        name: 'Flächentextoptionen...',
    },
    {
        id: 35,
        label: 'Ansicht > Zeichenfläche in Fenster einpassen',
        placement: 'MenuBar',
        name: 'Zeichenfläche in Fenster einpassen',
    },
    {
        id: 36,
        label: 'Fenster > Neues Fenster',
        placement: 'MenuBar',
        name: 'Neues Fenster',
    },
    {
        id: 37,
        label: 'Ansicht > Lineale > Lineale einblenden',
        placement: 'MenuBar',
        name: 'Lineale einblenden',
    },
    {
        id: 38,
        label: 'Schrift > Pfadtext > 3D-Band',
        placement: 'MenuBar',
        name: '3D-Band',
    },
    {
        id: 40,
        label: 'Schrift > Pfadtext > Treppenstufe',
        placement: 'MenuBar',
        name: 'Treppenstufe',
    },
    {
        id: 42,
        label: 'Objekt > Anordnen > In den Vordergrund',
        placement: 'MenuBar',
        name: 'In den Vordergrund',
    },
    {
        id: 43,
        label: 'Objekt > Anordnen > In den Hintergrund',
        placement: 'MenuBar',
        name: 'In den Hintergrund',
    },
    {
        id: 48,
        label: 'Datei > Als Vorlage speichern...',
        placement: 'MenuBar',
        name: 'Als Vorlage speichern...',
    },
    {
        id: 50,
        label: 'Objekt > Ausblenden > Auswahl',
        placement: 'MenuBar',
        name: 'Auswahl',
    },
    {
        id: 51,
        label: 'Objekt > Alles einblenden',
        placement: 'MenuBar',
        name: 'Alles einblenden',
    },
    {
        id: 52,
        label: 'Ansicht > Hilfslinien > Hilfslinien erstellen',
        placement: 'MenuBar',
        name: 'Hilfslinien erstellen',
    },
    {
        id: 53,
        label: 'Ansicht > Hilfslinien > Hilfslinien zurückwandeln',
        placement: 'MenuBar',
        name: 'Hilfslinien zurückwandeln',
    },
    {
        id: 54,
        label: 'Objekt > Transformieren > Verschieben...',
        placement: 'MenuBar',
        name: 'Verschieben...',
    },
    {
        id: 55,
        label: 'Illustrator > Voreinstellungen > Intelligente Hilfslinien...',
        placement: 'MenuBar',
        name: 'Intelligente Hilfslinien...',
    },
    {
        id: 56,
        label: 'Objekt > Zusammengesetzter Pfad > Erstellen',
        placement: 'MenuBar',
        name: 'Erstellen',
    },
    {
        id: 57,
        label: 'Objekt > Zusammengesetzter Pfad > Zurückwandeln',
        placement: 'MenuBar',
        name: 'Zurückwandeln',
    },
    {
        id: 62,
        label: 'Schrift > In Pfade umwandeln',
        placement: 'MenuBar',
        name: 'In Pfade umwandeln',
    },
    {
        id: 63,
        label: 'Ansicht > Originalgröße',
        placement: 'MenuBar',
        name: 'Originalgröße',
    },
    {
        id: 74,
        label: 'Objekt > Diagramm > Art...',
        placement: 'MenuBar',
        name: 'Art...',
    },
    {
        id: 75,
        label: 'Objekt > Diagramm > Daten...',
        placement: 'MenuBar',
        name: 'Daten...',
    },
    {
        id: 76,
        label: 'Objekt > Diagramm > Balken...',
        placement: 'MenuBar',
        name: 'Balken...',
    },
    {
        id: 77,
        label: 'Objekt > Diagramm > Designs...',
        placement: 'MenuBar',
        name: 'Designs...',
    },
    {
        id: 78,
        label: 'Objekt > Diagramm > Punkte...',
        placement: 'MenuBar',
        name: 'Punkte...',
    },
    {
        id: 83,
        label: 'Schrift > Pfadtext > Regenbogen',
        placement: 'MenuBar',
        name: 'Regenbogen',
    },
    {
        id: 84,
        label: 'Datei > Dokument einrichten...',
        placement: 'MenuBar',
        name: 'Dokument einrichten...',
    },
    {
        id: 85,
        label: 'Ansicht > Druckaufteilung ausblenden',
        placement: 'MenuBar',
        name: 'Druckaufteilung ausblenden',
    },
    {
        id: 86,
        label: 'Ansicht > Zeichenflächen ausblenden',
        placement: 'MenuBar',
        name: 'Zeichenflächen ausblenden',
    },
    {
        id: 87,
        label: 'Schrift > Überschrift einpassen',
        placement: 'MenuBar',
        name: 'Überschrift einpassen',
    },
    {
        id: 95,
        label: 'Datei > Kopie speichern...',
        placement: 'MenuBar',
        name: 'Kopie speichern...',
    },
    {
        id: 98,
        label: 'Illustrator > Voreinstellungen > Schrift...',
        placement: 'MenuBar',
        name: 'Schrift...',
    },
    {
        id: 99,
        label: 'Illustrator > Voreinstellungen > Einheit...',
        placement: 'MenuBar',
        name: 'Einheit...',
    },
    {
        id: 100,
        label: 'Objekt > Anordnen > Schrittweise nach vorne',
        placement: 'MenuBar',
        name: 'Schrittweise nach vorne',
    },
    {
        id: 101,
        label: 'Objekt > Anordnen > Schrittweise nach hinten',
        placement: 'MenuBar',
        name: 'Schrittweise nach hinten',
    },
    {
        id: 109,
        label: 'Fenster > Anordnen > Fenster minimieren',
        placement: 'MenuBar',
        name: 'Fenster minimieren',
    },
    {
        id: 110,
        label: 'Fenster > Anordnen > Alle in den Vordergrund',
        placement: 'MenuBar',
        name: 'Alle in den Vordergrund',
    },
    {
        id: 113,
        label: 'Ansicht > Hilfslinien > Hilfslinien löschen',
        placement: 'MenuBar',
        name: 'Hilfslinien löschen',
    },
    {
        id: 114,
        label: 'Ansicht > Vorlage einblenden',
        placement: 'MenuBar',
        name: 'Vorlage einblenden',
    },
    {
        id: 115,
        label: 'Schrift > Verborgene Zeichen einblenden',
        placement: 'MenuBar',
        name: 'Verborgene Zeichen einblenden',
    },
    {
        id: 116,
        label: 'Schrift > Pfadtext > Asymmetrie',
        placement: 'MenuBar',
        name: 'Asymmetrie',
    },
    {
        id: 117,
        label: 'Datei > Alle schließen',
        placement: 'MenuBar',
        name: 'Alle schließen',
    },
    {
        id: 119,
        label: 'Schrift > Pfadtext > Schwerkraft',
        placement: 'MenuBar',
        name: 'Schwerkraft',
    },
    {
        id: 120,
        label: 'Objekt > Schnittmaske > Erstellen',
        placement: 'MenuBar',
        name: 'Erstellen',
    },
    {
        id: 121,
        label: 'Objekt > Schnittmaske > Zurückwandeln',
        placement: 'MenuBar',
        name: 'Zurückwandeln',
    },
    {
        id: 123,
        label: 'Schrift > Pfadtext > Pfadtextoptionen...',
        placement: 'MenuBar',
        name: 'Pfadtextoptionen...',
    },
    {
        id: 127,
        label: 'Objekt > Zeichenflächen > In Zeichenflächen konvertieren',
        placement: 'MenuBar',
        name: 'In Zeichenflächen konvertieren',
    },
    {
        id: 133,
        label: 'Schrift > Verketteter Text > Erstellen',
        placement: 'MenuBar',
        name: 'Erstellen',
    },
    {
        id: 135,
        label: 'Ansicht > Einzoomen',
        placement: 'MenuBar',
        name: 'Einzoomen',
    },
    {
        id: 136,
        label: 'Ansicht > Auszoomen',
        placement: 'MenuBar',
        name: 'Auszoomen',
    },
    {
        id: 139,
        label: 'Bearbeiten > Farbeinstellungen...',
        placement: 'MenuBar',
        name: 'Farbeinstellungen...',
    },
    {
        id: 140,
        label: 'Illustrator > Voreinstellungen > Silbentrennung...',
        placement: 'MenuBar',
        name: 'Silbentrennung...',
    },
    {
        id: 141,
        label: 'Illustrator > Voreinstellungen > Zusatzmodule und virtueller Speicher...',
        placement: 'MenuBar',
        name: 'Zusatzmodule und virtueller Speicher...',
    },
    {
        id: 142,
        label: 'Auswahl > Auswahl aufheben',
        placement: 'MenuBar',
        name: 'Auswahl aufheben',
    },
    {
        id: 143,
        label: 'Ansicht > Überdruckenvorschau',
        placement: 'MenuBar',
        name: 'Überdruckenvorschau',
    },
    {
        id: 144,
        label: 'Ansicht > Neue Ansicht...',
        placement: 'MenuBar',
        name: 'Neue Ansicht...',
    },
    {
        id: 145,
        label: 'Ansicht > Ansicht bearbeiten...',
        placement: 'MenuBar',
        name: 'Ansicht bearbeiten...',
    },
    {
        id: 146,
        label: 'Ansicht > An Punkt ausrichten',
        placement: 'MenuBar',
        name: 'An Punkt ausrichten',
    },
    {
        id: 147,
        label: 'Ansicht > Ecken ausblenden',
        placement: 'MenuBar',
        name: 'Ecken ausblenden',
    },
    {
        id: 148,
        label: 'Objekt > Aussehen umwandeln',
        placement: 'MenuBar',
        name: 'Aussehen umwandeln',
    },
    {
        id: 150,
        label: 'Ansicht > Textverkettungen einblenden',
        placement: 'MenuBar',
        name: 'Textverkettungen einblenden',
    },
    {
        id: 154,
        label: 'Ansicht > Hilfslinien > Hilfslinien ausblenden',
        placement: 'MenuBar',
        name: 'Hilfslinien ausblenden',
    },
    {
        id: 155,
        label: 'Ansicht > Hilfslinien > Hilfslinien sperren',
        placement: 'MenuBar',
        name: 'Hilfslinien sperren',
    },
    {
        id: 157,
        label: 'Schrift > Verketteter Text > Auswahl zurückwandeln',
        placement: 'MenuBar',
        name: 'Auswahl zurückwandeln',
    },
    {
        id: 158,
        label: 'Schrift > Verketteter Text > Verkettung entfernen',
        placement: 'MenuBar',
        name: 'Verkettung entfernen',
    },
    {
        id: 159,
        label: 'Ansicht > Raster einblenden',
        placement: 'MenuBar',
        name: 'Raster einblenden',
    },
    {
        id: 160,
        label: 'Ansicht > Am Raster ausrichten',
        placement: 'MenuBar',
        name: 'Am Raster ausrichten',
    },
    {
        id: 161,
        label: 'Illustrator > Voreinstellungen > Hilfslinien und Raster...',
        placement: 'MenuBar',
        name: 'Hilfslinien und Raster...',
    },
    {
        id: 162,
        label: 'Objekt > Transformieren > Drehen...',
        placement: 'MenuBar',
        name: 'Drehen...',
    },
    {
        id: 163,
        label: 'Objekt > Transformieren > Skalieren...',
        placement: 'MenuBar',
        name: 'Skalieren...',
    },
    {
        id: 164,
        label: 'Objekt > Transformieren > Spiegeln...',
        placement: 'MenuBar',
        name: 'Spiegeln...',
    },
    {
        id: 165,
        label: 'Objekt > Transformieren > Verbiegen...',
        placement: 'MenuBar',
        name: 'Verbiegen...',
    },
    {
        id: 166,
        label: 'Fenster > Anordnen > Überlappend',
        placement: 'MenuBar',
        name: 'Überlappend',
    },
    {
        id: 168,
        label: 'Fenster > Anordnen > Nebeneinander',
        placement: 'MenuBar',
        name: 'Nebeneinander',
    },
    {
        id: 202,
        label: 'Ansicht > Farbproof',
        placement: 'MenuBar',
        name: 'Farbproof',
    },
    {
        id: 203,
        label: 'Bearbeiten > Profil zuweisen...',
        placement: 'MenuBar',
        name: 'Profil zuweisen...',
    },
    {
        id: 204,
        label: 'Hilfe > Tutorials...',
        placement: 'MenuBar',
        name: 'Tutorials...',
    },
    {
        id: 223,
        label: 'Datei > Dokumentfarbmodus > CMYK-Farbe',
        placement: 'MenuBar',
        name: 'CMYK-Farbe',
    },
    {
        id: 224,
        label: 'Datei > Dokumentfarbmodus > RGB-Farbe',
        placement: 'MenuBar',
        name: 'RGB-Farbe',
    },
    {
        id: 225,
        label: 'Ansicht > Proof einrichten > Dokument-CMYK:',
        placement: 'MenuBar',
        name: 'Dokument-CMYK:',
    },
    {
        id: 226,
        label: 'Ansicht > Proof einrichten > Altes Macintosh-RGB (Gamma 1.8)',
        placement: 'MenuBar',
        name: 'Altes Macintosh-RGB (Gamma 1.8)',
    },
    {
        id: 227,
        label: 'Ansicht > Proof einrichten > Internet-Standard-RGB (sRGB)',
        placement: 'MenuBar',
        name: 'Internet-Standard-RGB (sRGB)',
    },
    {
        id: 228,
        label: 'Ansicht > Proof einrichten > Monitor-RGB',
        placement: 'MenuBar',
        name: 'Monitor-RGB',
    },
    {
        id: 229,
        label: 'Schrift > Textausrichtung > Horizontal',
        placement: 'MenuBar',
        name: 'Horizontal',
    },
    {
        id: 230,
        label: 'Schrift > Textausrichtung > Vertikal',
        placement: 'MenuBar',
        name: 'Vertikal',
    },
    {
        id: 232,
        label: 'Hilfe > Systeminformationen...',
        placement: 'MenuBar',
        name: 'Systeminformationen...',
    },
    {
        id: 278,
        label: 'Schrift > Alter Text > Ganzen alten Text aktualisieren',
        placement: 'MenuBar',
        name: 'Ganzen alten Text aktualisieren',
    },
    {
        id: 279,
        label: 'Schrift > Alter Text > Ausgewählten alten Text aktualisieren',
        placement: 'MenuBar',
        name: 'Ausgewählten alten Text aktualisieren',
    },
    {
        id: 280,
        label: 'Schrift > Alter Text > Kopien ausblenden',
        placement: 'MenuBar',
        name: 'Kopien ausblenden',
    },
    {
        id: 281,
        label: 'Schrift > Alter Text > Kopien löschen',
        placement: 'MenuBar',
        name: 'Kopien löschen',
    },
    {
        id: 282,
        label: 'Schrift > Alter Text > Kopien auswählen',
        placement: 'MenuBar',
        name: 'Kopien auswählen',
    },
    {
        id: 284,
        label: 'Ansicht > Proof einrichten > Anpassen...',
        placement: 'MenuBar',
        name: 'Anpassen...',
    },
    {
        id: 289,
        label: 'Illustrator > Voreinstellungen > Auswahl und Ankerpunkt-Anzeige...',
        placement: 'MenuBar',
        name: 'Auswahl und Ankerpunkt-Anzeige...',
    },
    {
        id: 292,
        label: 'Objekt > Schnittmaske > Inhalte bearbeiten',
        placement: 'MenuBar',
        name: 'Inhalte bearbeiten',
    },
    {
        id: 293,
        label: 'Illustrator > Voreinstellungen > Benutzeroberfläche...',
        placement: 'MenuBar',
        name: 'Benutzeroberfläche...',
    },
    {
        id: 294,
        label: 'Illustrator > Voreinstellungen > Slices...',
        placement: 'MenuBar',
        name: 'Slices...',
    },
    {
        id: 295,
        label: 'Fenster > Anwendungsrahmen',
        placement: 'MenuBar',
        name: 'Anwendungsrahmen',
    },
    {
        id: 296,
        label: 'Ansicht > Proof einrichten > Farbenblindheit (Protanopie)',
        placement: 'MenuBar',
        name: 'Farbenblindheit (Protanopie)',
    },
    {
        id: 297,
        label: 'Ansicht > Proof einrichten > Farbenblindheit (Deuteranopie)',
        placement: 'MenuBar',
        name: 'Farbenblindheit (Deuteranopie)',
    },
    {
        id: 299,
        label: 'Ansicht > Lineale > Videolineale einblenden',
        placement: 'MenuBar',
        name: 'Videolineale einblenden',
    },
    {
        id: 301,
        label: 'Fenster > Anordnen > In Fenster verschiebbar machen',
        placement: 'MenuBar',
        name: 'In Fenster verschiebbar machen',
    },
    {
        id: 302,
        label: 'Fenster > Anordnen > Alle in Fenstern verschiebbar machen',
        placement: 'MenuBar',
        name: 'Alle in Fenstern verschiebbar machen',
    },
    {
        id: 303,
        label: 'Fenster > Anordnen > Alle Fenster zusammenführen',
        placement: 'MenuBar',
        name: 'Alle Fenster zusammenführen',
    },
    {
        id: 304,
        label: 'Fenster > Anwendungsleiste',
        placement: 'MenuBar',
        name: 'Anwendungsleiste',
    },
    {
        id: 310,
        label: 'Schrift > Pfadtext > Alten Pfadtext aktualisieren',
        placement: 'MenuBar',
        name: 'Alten Pfadtext aktualisieren',
    },
    {
        id: 311,
        label: 'Ansicht > Alle in Fenster einpassen',
        placement: 'MenuBar',
        name: 'Alle in Fenster einpassen',
    },
    {
        id: 315,
        label: 'Bearbeiten > An Originalposition einfügen',
        placement: 'MenuBar',
        name: 'An Originalposition einfügen',
    },
    {
        id: 316,
        label: 'Bearbeiten > In alle Zeichenflächen einfügen',
        placement: 'MenuBar',
        name: 'In alle Zeichenflächen einfügen',
    },
    {
        id: 331,
        label: 'Schrift > Schriftumwandlung',
        placement: 'MenuBar',
        name: 'Schriftumwandlung',
    },
    {
        id: 339,
        label: 'Bearbeiten > Meine Einstellungen > Einstellungen exportieren...',
        placement: 'MenuBar',
        name: 'Einstellungen exportieren...',
    },
    {
        id: 340,
        label: 'Bearbeiten > Meine Einstellungen > Einstellungen importieren...',
        placement: 'MenuBar',
        name: 'Einstellungen importieren...',
    },
    {
        id: 347,
        label: 'Ansicht > Mit GPU anzeigen',
        placement: 'MenuBar',
        name: 'Mit GPU anzeigen',
    },
    {
        id: 351,
        label: 'Datei > Auswahl exportieren...',
        placement: 'MenuBar',
        name: 'Auswahl exportieren...',
    },
    {
        id: 353,
        label: 'Ansicht > An Pixel ausrichten',
        placement: 'MenuBar',
        name: 'An Pixel ausrichten',
    },
    {
        id: 354,
        label: 'Datei > Exportieren > Für Bildschirme exportieren...',
        placement: 'MenuBar',
        name: 'Für Bildschirme exportieren...',
    },
    {
        id: 355,
        label: 'Datei > Exportieren > Exportieren als...',
        placement: 'MenuBar',
        name: 'Exportieren als...',
    },
    {
        id: 356,
        label: 'Datei > Exportieren > Für Web speichern (Legacy)...',
        placement: 'MenuBar',
        name: 'Für Web speichern (Legacy)...',
    },
    {
        id: 368,
        label: 'Schrift > Sonderzeichen einfügen > Symbole > Aufzählungszeichen',
        placement: 'MenuBar',
        name: 'Aufzählungszeichen',
    },
    {
        id: 369,
        label: 'Schrift > Sonderzeichen einfügen > Symbole > Copyrightsymbol',
        placement: 'MenuBar',
        name: 'Copyrightsymbol',
    },
    {
        id: 370,
        label: 'Schrift > Sonderzeichen einfügen > Symbole > Auslassungszeichen',
        placement: 'MenuBar',
        name: 'Auslassungszeichen',
    },
    {
        id: 371,
        label: 'Schrift > Sonderzeichen einfügen > Symbole > Absatzmarke',
        placement: 'MenuBar',
        name: 'Absatzmarke',
    },
    {
        id: 372,
        label: 'Schrift > Sonderzeichen einfügen > Symbole > Symbol für eingetragene Marke',
        placement: 'MenuBar',
        name: 'Symbol für eingetragene Marke',
    },
    {
        id: 373,
        label: 'Schrift > Sonderzeichen einfügen > Symbole > Paragraphenzeichen',
        placement: 'MenuBar',
        name: 'Paragraphenzeichen',
    },
    {
        id: 374,
        label: 'Schrift > Sonderzeichen einfügen > Symbole > Symbol für Marke',
        placement: 'MenuBar',
        name: 'Symbol für Marke',
    },
    {
        id: 375,
        label: 'Schrift > Sonderzeichen einfügen > Anführungszeichen > Öffnende dopp. Anführ.zeichen',
        placement: 'MenuBar',
        name: 'Öffnende dopp. Anführ.zeichen',
    },
    {
        id: 376,
        label: 'Schrift > Sonderzeichen einfügen > Anführungszeichen > Schließende dopp. Anführ.zeich.',
        placement: 'MenuBar',
        name: 'Schließende dopp. Anführ.zeich.',
    },
    {
        id: 377,
        label: 'Schrift > Sonderzeichen einfügen > Anführungszeichen > Öffnende einf. Anführ.zeichen',
        placement: 'MenuBar',
        name: 'Öffnende einf. Anführ.zeichen',
    },
    {
        id: 378,
        label: 'Schrift > Sonderzeichen einfügen > Anführungszeichen > Schließende einf. Anführ.zeichen',
        placement: 'MenuBar',
        name: 'Schließende einf. Anführ.zeichen',
    },
    {
        id: 379,
        label: 'Schrift > Sonderzeichen einfügen > Trenn- und Gedankenstriche > Geviertstrich',
        placement: 'MenuBar',
        name: 'Geviertstrich',
    },
    {
        id: 380,
        label: 'Schrift > Sonderzeichen einfügen > Trenn- und Gedankenstriche > Halbgeviertstrich',
        placement: 'MenuBar',
        name: 'Halbgeviertstrich',
    },
    {
        id: 381,
        label: 'Schrift > Sonderzeichen einfügen > Trenn- und Gedankenstriche > Bedingter Trennstrich',
        placement: 'MenuBar',
        name: 'Bedingter Trennstrich',
    },
    {
        id: 382,
        label: 'Schrift > Leerraumzeichen einfügen > Geviert',
        placement: 'MenuBar',
        name: 'Geviert',
    },
    {
        id: 383,
        label: 'Schrift > Leerraumzeichen einfügen > Halbgeviert',
        placement: 'MenuBar',
        name: 'Halbgeviert',
    },
    {
        id: 384,
        label: 'Schrift > Leerraumzeichen einfügen > 1/24-Geviert',
        placement: 'MenuBar',
        name: '1/24-Geviert',
    },
    {
        id: 385,
        label: 'Schrift > Leerraumzeichen einfügen > Achtelgeviert',
        placement: 'MenuBar',
        name: 'Achtelgeviert',
    },
    {
        id: 386,
        label: 'Schrift > Umbruchzeichen einfügen > Harter Zeilenumbruch',
        placement: 'MenuBar',
        name: 'Harter Zeilenumbruch',
    },
    {
        id: 391,
        label: 'Schrift > Mit Platzhaltertext füllen',
        placement: 'MenuBar',
        name: 'Mit Platzhaltertext füllen',
    },
    {
        id: 393,
        label: 'Objekt > Für Export sammeln > Als Einzelelement',
        placement: 'MenuBar',
        name: 'Als Einzelelement',
    },
    {
        id: 394,
        label: 'Objekt > Für Export sammeln > Als mehrere Elemente',
        placement: 'MenuBar',
        name: 'Als mehrere Elemente',
    },
    {
        id: 396,
        label: 'Ansicht > Ansicht zuschneiden',
        placement: 'MenuBar',
        name: 'Ansicht zuschneiden',
    },
    {
        id: 397,
        label: 'Ansicht > Präsentationsmodus',
        placement: 'MenuBar',
        name: 'Präsentationsmodus',
    },
    {
        id: 404,
        label: 'Ansicht > Bildschirmmodus > Normaler Bildschirmmodus',
        placement: 'MenuBar',
        name: 'Normaler Bildschirmmodus',
    },
    {
        id: 405,
        label: 'Ansicht > Bildschirmmodus > Vollbildmodus mit Menüleiste',
        placement: 'MenuBar',
        name: 'Vollbildmodus mit Menüleiste',
    },
    {
        id: 406,
        label: 'Ansicht > Bildschirmmodus > Vollbildmodus',
        placement: 'MenuBar',
        name: 'Vollbildmodus',
    },
    {
        id: 411,
        label: 'Ansicht > An Glyphe ausrichten',
        placement: 'MenuBar',
        name: 'An Glyphe ausrichten',
    },
    {
        id: 415,
        label: 'Ansicht > Ansicht zur Auswahl drehen',
        placement: 'MenuBar',
        name: 'Ansicht zur Auswahl drehen',
    },
    {
        id: 417,
        label: 'Ansicht > Ansicht drehen > 180',
        placement: 'MenuBar',
        name: '180',
    },
    {
        id: 418,
        label: 'Ansicht > Ansicht drehen > 150',
        placement: 'MenuBar',
        name: '150',
    },
    {
        id: 419,
        label: 'Ansicht > Ansicht drehen > 135',
        placement: 'MenuBar',
        name: '135',
    },
    {
        id: 420,
        label: 'Ansicht > Ansicht drehen > 120',
        placement: 'MenuBar',
        name: '120',
    },
    {
        id: 421,
        label: 'Ansicht > Ansicht drehen > 90',
        placement: 'MenuBar',
        name: '90',
    },
    {
        id: 422,
        label: 'Ansicht > Ansicht drehen > 60',
        placement: 'MenuBar',
        name: '60',
    },
    {
        id: 423,
        label: 'Ansicht > Ansicht drehen > 45',
        placement: 'MenuBar',
        name: '45',
    },
    {
        id: 424,
        label: 'Ansicht > Ansicht drehen > 30',
        placement: 'MenuBar',
        name: '30',
    },
    {
        id: 425,
        label: 'Ansicht > Ansicht drehen > 15',
        placement: 'MenuBar',
        name: '15',
    },
    {
        id: 426,
        label: 'Ansicht > Ansicht drehen > 0',
        placement: 'MenuBar',
        name: '0',
    },
    {
        id: 427,
        label: 'Ansicht > Ansicht drehen > -15',
        placement: 'MenuBar',
        name: '-15',
    },
    {
        id: 428,
        label: 'Ansicht > Ansicht drehen > -30',
        placement: 'MenuBar',
        name: '-30',
    },
    {
        id: 429,
        label: 'Ansicht > Ansicht drehen > -45',
        placement: 'MenuBar',
        name: '-45',
    },
    {
        id: 430,
        label: 'Ansicht > Ansicht drehen > -60',
        placement: 'MenuBar',
        name: '-60',
    },
    {
        id: 431,
        label: 'Ansicht > Ansicht drehen > -90',
        placement: 'MenuBar',
        name: '-90',
    },
    {
        id: 432,
        label: 'Ansicht > Ansicht drehen > -120',
        placement: 'MenuBar',
        name: '-120',
    },
    {
        id: 433,
        label: 'Ansicht > Ansicht drehen > -135',
        placement: 'MenuBar',
        name: '-135',
    },
    {
        id: 434,
        label: 'Ansicht > Ansicht drehen > -150',
        placement: 'MenuBar',
        name: '-150',
    },
    {
        id: 435,
        label: 'Ansicht > Ansicht drehen > -180',
        placement: 'MenuBar',
        name: '-180',
    },
    {
        id: 436,
        label: 'Ansicht > „Ansicht drehen“ zurücksetzen',
        placement: 'MenuBar',
        name: '„Ansicht drehen“ zurücksetzen',
    },
    {
        id: 437,
        label: 'Bearbeiten > Ohne Formatierung einfügen',
        placement: 'MenuBar',
        name: 'Ohne Formatierung einfügen',
    },
    {
        id: 438,
        label: 'Hilfe > Neuerungen...',
        placement: 'MenuBar',
        name: 'Neuerungen...',
    },
    {
        id: 440,
        label: 'Schrift > Aufzählungszeichen und Nummerierung > Aufzählungszeichen anwenden',
        placement: 'MenuBar',
        name: 'Aufzählungszeichen anwenden',
    },
    {
        id: 441,
        label: 'Schrift > Aufzählungszeichen und Nummerierung > Nummern anwenden',
        placement: 'MenuBar',
        name: 'Nummern anwenden',
    },
    {
        id: 448,
        label: 'Schrift > Aufzählungszeichen und Nummerierung > In Text konvertieren',
        placement: 'MenuBar',
        name: 'In Text konvertieren',
    },
    {
        id: 456,
        label: 'Schrift > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 471,
        label: 'Objekt > Alle Gruppierungen aufheben',
        placement: 'MenuBar',
        name: 'Alle Gruppierungen aufheben',
    },
    {
        id: 472,
        label: 'Schrift > Leerraumzeichen einfügen > Geschütztes Leerzeichen',
        placement: 'MenuBar',
        name: 'Geschütztes Leerzeichen',
    },
    {
        id: 1383427079,
        label: 'Ansicht > Lineale > In Zeichenflächenlineale ändern',
        placement: 'MenuBar',
        name: 'In Zeichenflächenlineale ändern',
    },
    {
        id: 1633841013,
        label: 'Illustrator > Über Illustrator...',
        placement: 'MenuBar',
        name: 'Über Illustrator...',
    },
    {
        id: 1634233456,
        label: 'Hilfe > Illustrator-Hilfe...',
        placement: 'MenuBar',
        name: 'Illustrator-Hilfe...',
    },
    {
        id: 1634296684,
        label: 'Datei > Schließen',
        placement: 'MenuBar',
        name: 'Schließen',
    },
    {
        id: 1668048225,
        label: 'Bearbeiten > Löschen',
        placement: 'MenuBar',
        name: 'Löschen',
    },
    {
        id: 1668247673,
        label: 'Bearbeiten > Kopieren',
        placement: 'MenuBar',
        name: 'Kopieren',
    },
    {
        id: 1668641824,
        label: 'Bearbeiten > Ausschneiden',
        placement: 'MenuBar',
        name: 'Ausschneiden',
    },
    {
        id: 1751737445,
        label: 'Illustrator > Illustrator ausblenden',
        placement: 'MenuBar',
        name: 'Illustrator ausblenden',
    },
    {
        id: 1751737455,
        label: 'Illustrator > Andere ausblenden',
        placement: 'MenuBar',
        name: 'Andere ausblenden',
    },
    {
        id: 1852143392,
        label: 'Datei > Neu...',
        placement: 'MenuBar',
        name: 'Neu...',
    },
    {
        id: 1869636974,
        label: 'Datei > Öffnen...',
        placement: 'MenuBar',
        name: 'Öffnen...',
    },
    {
        id: 1885434740,
        label: 'Bearbeiten > Einfügen',
        placement: 'MenuBar',
        name: 'Einfügen',
    },
    {
        id: 1886545254,
        label: 'Illustrator > Voreinstellungen > Allgemein...',
        placement: 'MenuBar',
        name: 'Allgemein...',
    },
    {
        id: 1903520116,
        label: 'Illustrator > Illustrator beenden',
        placement: 'MenuBar',
        name: 'Illustrator beenden',
    },
    {
        id: 1919247471,
        label: 'Bearbeiten > Wiederholen',
        placement: 'MenuBar',
        name: 'Wiederholen',
    },
    {
        id: 1920365172,
        label: 'Datei > Zurück zur letzten Version',
        placement: 'MenuBar',
        name: 'Zurück zur letzten Version',
    },
    {
        id: 1934727834,
        label: 'Auswahl > Alles auf der aktiven Zeichenfläche',
        placement: 'MenuBar',
        name: 'Alles auf der aktiven Zeichenfläche',
    },
    {
        id: 1935764588,
        label: 'Auswahl > Alles auswählen',
        placement: 'MenuBar',
        name: 'Alles auswählen',
    },
    {
        id: 1935767141,
        label: 'Datei > Speichern',
        placement: 'MenuBar',
        name: 'Speichern',
    },
    {
        id: 1936220524,
        label: 'Illustrator > Alles einblenden',
        placement: 'MenuBar',
        name: 'Alles einblenden',
    },
    {
        id: 1936292352,
        label: 'Schrift > Schriftgrad > 6 pt',
        placement: 'MenuBar',
        name: '6 pt',
    },
    {
        id: 1936292353,
        label: 'Schrift > Schriftgrad > 7 Pt',
        placement: 'MenuBar',
        name: '7 Pt',
    },
    {
        id: 1936292354,
        label: 'Schrift > Schriftgrad > 8 Pt',
        placement: 'MenuBar',
        name: '8 Pt',
    },
    {
        id: 1936292355,
        label: 'Schrift > Schriftgrad > 9 Pt',
        placement: 'MenuBar',
        name: '9 Pt',
    },
    {
        id: 1936292356,
        label: 'Schrift > Schriftgrad > 10 Pt',
        placement: 'MenuBar',
        name: '10 Pt',
    },
    {
        id: 1936292357,
        label: 'Schrift > Schriftgrad > 11 Pt',
        placement: 'MenuBar',
        name: '11 Pt',
    },
    {
        id: 1936292358,
        label: 'Schrift > Schriftgrad > 12 Pt',
        placement: 'MenuBar',
        name: '12 Pt',
    },
    {
        id: 1936292359,
        label: 'Schrift > Schriftgrad > 14 Pt',
        placement: 'MenuBar',
        name: '14 Pt',
    },
    {
        id: 1936292360,
        label: 'Schrift > Schriftgrad > 18 Pt',
        placement: 'MenuBar',
        name: '18 Pt',
    },
    {
        id: 1936292361,
        label: 'Schrift > Schriftgrad > 21 Pt',
        placement: 'MenuBar',
        name: '21 Pt',
    },
    {
        id: 1936292362,
        label: 'Schrift > Schriftgrad > 24 Pt',
        placement: 'MenuBar',
        name: '24 Pt',
    },
    {
        id: 1936292363,
        label: 'Schrift > Schriftgrad > 36 Pt',
        placement: 'MenuBar',
        name: '36 Pt',
    },
    {
        id: 1936292364,
        label: 'Schrift > Schriftgrad > 48 Pt',
        placement: 'MenuBar',
        name: '48 Pt',
    },
    {
        id: 1936292365,
        label: 'Schrift > Schriftgrad > 60 Pt',
        placement: 'MenuBar',
        name: '60 Pt',
    },
    {
        id: 1936292366,
        label: 'Schrift > Schriftgrad > 72 Pt',
        placement: 'MenuBar',
        name: '72 Pt',
    },
    {
        id: 1936292367,
        label: 'Schrift > Schriftgrad > Anderer Wert...',
        placement: 'MenuBar',
        name: 'Anderer Wert...',
    },
    {
        id: 1937138035,
        label: 'Datei > Speichern unter...',
        placement: 'MenuBar',
        name: 'Speichern unter...',
    },
    {
        id: 1970168943,
        label: 'Bearbeiten > Rückgängig',
        placement: 'MenuBar',
        name: 'Rückgängig',
    },
    {
        id: 2164260867,
        label: 'Hilfe > Mein Konto verwalten...',
        placement: 'MenuBar',
        name: 'Mein Konto verwalten...',
    },
    {
        id: 2164260869,
        label: 'Hilfe > Update...',
        placement: 'MenuBar',
        name: 'Update...',
    },
    {
        id: 2164260870,
        label: 'Effekt > Letzten Effekt anwenden',
        placement: 'MenuBar',
        name: 'Letzten Effekt anwenden',
    },
    {
        id: 2164260871,
        label: 'Effekt > Letzter Effekt',
        placement: 'MenuBar',
        name: 'Letzter Effekt',
    },
    {
        id: 2164260872,
        label: 'Datei > Adobe Stock durchsuchen…',
        placement: 'MenuBar',
        name: 'Adobe Stock durchsuchen…',
    },
    {
        id: 2164260873,
        label: 'Datei > Platzieren...',
        placement: 'MenuBar',
        name: 'Platzieren...',
    },
    {
        id: 2164260874,
        label: 'Objekt > Pfad > Ankerpunkte entfernen',
        placement: 'MenuBar',
        name: 'Ankerpunkte entfernen',
    },
    {
        id: 2164260877,
        label: 'Hilfe > Debug > Memory Use Checkpoint',
        placement: 'MenuBar',
        name: 'Memory Use Checkpoint',
    },
    {
        id: 2164260878,
        label: 'Hilfe > Debug > Save Memory Use',
        placement: 'MenuBar',
        name: 'Save Memory Use',
    },
    {
        id: 2164260880,
        label: 'Hilfe > Debug > Progress: Bar Shown',
        placement: 'MenuBar',
        name: 'Progress: Bar Shown',
    },
    {
        id: 2164260881,
        label: 'Hilfe > Debug > Progress: Tight loop for 120 Seconds',
        placement: 'MenuBar',
        name: 'Progress: Tight loop for 120 Seconds',
    },
    {
        id: 2164260882,
        label: 'Hilfe > Debug > Responsive Rate Test',
        placement: 'MenuBar',
        name: 'Responsive Rate Test',
    },
    {
        id: 2164260883,
        label: 'Hilfe > Debug > Test Notification 1',
        placement: 'MenuBar',
        name: 'Test Notification 1',
    },
    {
        id: 2164260884,
        label: 'Hilfe > Debug > Test Notification 2',
        placement: 'MenuBar',
        name: 'Test Notification 2',
    },
    {
        id: 2164260885,
        label: 'Hilfe > Debug > Test Notification 3',
        placement: 'MenuBar',
        name: 'Test Notification 3',
    },
    {
        id: 2164260887,
        label: 'Hilfe > Debug > Count Objects',
        placement: 'MenuBar',
        name: 'Count Objects',
    },
    {
        id: 2164260888,
        label: 'Hilfe > Debug > Object Counts',
        placement: 'MenuBar',
        name: 'Object Counts',
    },
    {
        id: 2164260890,
        label: 'Hilfe > Debug > Track API Refs',
        placement: 'MenuBar',
        name: 'Track API Refs',
    },
    {
        id: 2164260891,
        label: 'Hilfe > Debug > Process Deep Link',
        placement: 'MenuBar',
        name: 'Process Deep Link',
    },
    {
        id: 2164260892,
        label: 'Hilfe > Debug > Start Discover Panel Tour',
        placement: 'MenuBar',
        name: 'Start Discover Panel Tour',
    },
    {
        id: 2164260894,
        label: 'Hilfe > Debug > Enable New Rendering',
        placement: 'MenuBar',
        name: 'Enable New Rendering',
    },
    {
        id: 2164260895,
        label: 'Hilfe > Debug > Enable Rendering Timer',
        placement: 'MenuBar',
        name: 'Enable Rendering Timer',
    },
    {
        id: 2164260896,
        label: 'Hilfe > Debug > Purge Rendering Cache',
        placement: 'MenuBar',
        name: 'Purge Rendering Cache',
    },
    {
        id: 2164260897,
        label: 'Hilfe > Debug > Redraw',
        placement: 'MenuBar',
        name: 'Redraw',
    },
    {
        id: 2164260898,
        label: 'Hilfe > Debug > Dump Application Heap Used',
        placement: 'MenuBar',
        name: 'Dump Application Heap Used',
    },
    {
        id: 2164260899,
        label: 'Hilfe > Debug > Disable Greeking for New Rendering',
        placement: 'MenuBar',
        name: 'Disable Greeking for New Rendering',
    },
    {
        id: 2164260900,
        label: 'Hilfe > Debug > Enable Threaded Rendering',
        placement: 'MenuBar',
        name: 'Enable Threaded Rendering',
    },
    {
        id: 2164260901,
        label: 'Hilfe > Debug > Enable AGM Threading',
        placement: 'MenuBar',
        name: 'Enable AGM Threading',
    },
    {
        id: 2164260902,
        label: 'Hilfe > Debug > Enable AGM Internal Memory Pool',
        placement: 'MenuBar',
        name: 'Enable AGM Internal Memory Pool',
    },
    {
        id: 2164260903,
        label: 'Hilfe > Debug > Enable QuickPort Quartz',
        placement: 'MenuBar',
        name: 'Enable QuickPort Quartz',
    },
    {
        id: 2164260904,
        label: 'Hilfe > Debug > Crash',
        placement: 'MenuBar',
        name: 'Crash',
    },
    {
        id: 2164260906,
        label: 'Hilfe > Debug > Enable PGF Recovery',
        placement: 'MenuBar',
        name: 'Enable PGF Recovery',
    },
    {
        id: 2164260907,
        label: 'Hilfe > Debug > Enable ATE Read Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Read Recovery',
    },
    {
        id: 2164260908,
        label: 'Hilfe > Debug > Enable ATE Write Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Write Recovery',
    },
    {
        id: 2164260910,
        label: 'Fenster > Info',
        placement: 'MenuBar',
        name: 'Info',
    },
    {
        id: 2164260912,
        label: 'Fenster > Schrift > Zeichen',
        placement: 'MenuBar',
        name: 'Zeichen',
    },
    {
        id: 2164260913,
        label: 'Fenster > Schrift > Absatz',
        placement: 'MenuBar',
        name: 'Absatz',
    },
    {
        id: 2164260914,
        label: 'Fenster > Schrift > Tabulatoren',
        placement: 'MenuBar',
        name: 'Tabulatoren',
    },
    {
        id: 2164260915,
        label: 'Fenster > Schrift > OpenType',
        placement: 'MenuBar',
        name: 'OpenType',
    },
    {
        id: 2164260916,
        label: 'Effekt > Photoshop-Effekte',
        placement: 'MenuBar',
        name: 'Photoshop-Effekte',
    },
    {
        id: 2164260919,
        label: 'Effekt > Weichzeichnungsfilter > Selektiver Weichzeichner...',
        placement: 'MenuBar',
        name: 'Selektiver Weichzeichner...',
    },
    {
        id: 2164260920,
        label: 'Effekt > Weichzeichnungsfilter > Radialer Weichzeichner...',
        placement: 'MenuBar',
        name: 'Radialer Weichzeichner...',
    },
    {
        id: 2164260922,
        label: 'Effekt > Vergröberungsfilter > Punktieren...',
        placement: 'MenuBar',
        name: 'Punktieren...',
    },
    {
        id: 2164260923,
        label: 'Effekt > Vergröberungsfilter > Mezzotint...',
        placement: 'MenuBar',
        name: 'Mezzotint...',
    },
    {
        id: 2164260925,
        label: 'Effekt > Videofilter > De-Interlace...',
        placement: 'MenuBar',
        name: 'De-Interlace...',
    },
    {
        id: 2164260926,
        label: 'Effekt > Vergröberungsfilter > Kristallisieren...',
        placement: 'MenuBar',
        name: 'Kristallisieren...',
    },
    {
        id: 2164260927,
        label: 'Effekt > Vergröberungsfilter > Farbraster...',
        placement: 'MenuBar',
        name: 'Farbraster...',
    },
    {
        id: 2164260928,
        label: 'Ansicht > Interaktive Mallücken einblenden',
        placement: 'MenuBar',
        name: 'Interaktive Mallücken einblenden',
    },
    {
        id: 2164260931,
        label: 'Objekt > Interaktiv malen > Erstellen',
        placement: 'MenuBar',
        name: 'Erstellen',
    },
    {
        id: 2164260932,
        label: 'Objekt > Interaktiv malen > Zusammenfügen',
        placement: 'MenuBar',
        name: 'Zusammenfügen',
    },
    {
        id: 2164260933,
        label: 'Objekt > Interaktiv malen > Zurückwandeln',
        placement: 'MenuBar',
        name: 'Zurückwandeln',
    },
    {
        id: 2164260935,
        label: 'Objekt > Interaktiv malen > Lückenoptionen...',
        placement: 'MenuBar',
        name: 'Lückenoptionen...',
    },
    {
        id: 2164260937,
        label: 'Objekt > Interaktiv malen > Umwandeln',
        placement: 'MenuBar',
        name: 'Umwandeln',
    },
    {
        id: 2164260938,
        label: 'Fenster > Bibliotheken',
        placement: 'MenuBar',
        name: 'Bibliotheken',
    },
    {
        id: 2164260940,
        label: 'Fenster > Erweiterungen auf Exchange suchen...',
        placement: 'MenuBar',
        name: 'Erweiterungen auf Exchange suchen...',
    },
    {
        id: 2164260941,
        label: 'Fenster > Separationenvorschau',
        placement: 'MenuBar',
        name: 'Separationenvorschau',
    },
    {
        id: 2164260942,
        label: 'Fenster > Verknüpfungen',
        placement: 'MenuBar',
        name: 'Verknüpfungen',
    },
    {
        id: 2164260944,
        label: 'Bearbeiten > Original bearbeiten',
        placement: 'MenuBar',
        name: 'Original bearbeiten',
    },
    {
        id: 2164260946,
        label: 'Fenster > Schrift > Absatzformate',
        placement: 'MenuBar',
        name: 'Absatzformate',
    },
    {
        id: 2164260947,
        label: 'Fenster > Schrift > Zeichenformate',
        placement: 'MenuBar',
        name: 'Zeichenformate',
    },
    {
        id: 2164260948,
        label: 'Fenster > Zeichenflächen',
        placement: 'MenuBar',
        name: 'Zeichenflächen',
    },
    {
        id: 2164260950,
        label: 'Objekt > Zeichenflächen > Alle Zeichenflächen neu anordnen',
        placement: 'MenuBar',
        name: 'Alle Zeichenflächen neu anordnen',
    },
    {
        id: 2164260952,
        label: 'Objekt > Zeichenflächen > An Bildmaterialbegrenzungen anpassen',
        placement: 'MenuBar',
        name: 'An Bildmaterialbegrenzungen anpassen',
    },
    {
        id: 2164260953,
        label: 'Objekt > Zeichenflächen > An ausgewählte Grafik anpassen',
        placement: 'MenuBar',
        name: 'An ausgewählte Grafik anpassen',
    },
    {
        id: 2164260954,
        label: 'Fenster > Eigenschaften',
        placement: 'MenuBar',
        name: 'Eigenschaften',
    },
    {
        id: 2164260955,
        label: 'Fenster > Navigator',
        placement: 'MenuBar',
        name: 'Navigator',
    },
    {
        id: 2164260958,
        label: 'Fenster > Arbeitsbereich > Zurücksetzen: Getting Started',
        placement: 'MenuBar',
        name: 'Zurücksetzen: Getting Started',
    },
    {
        id: 2164260959,
        label: 'Fenster > Arbeitsbereich > Neuer Arbeitsbereich...',
        placement: 'MenuBar',
        name: 'Neuer Arbeitsbereich...',
    },
    {
        id: 2164260960,
        label: 'Fenster > Arbeitsbereich > Arbeitsbereiche verwalten...',
        placement: 'MenuBar',
        name: 'Arbeitsbereiche verwalten...',
    },
    {
        id: 2164260961,
        label: 'Fenster > Arbeitsbereich > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164260962,
        label: 'Fenster > Arbeitsbereich > Grundlagen – klassisch',
        placement: 'MenuBar',
        name: 'Grundlagen – klassisch',
    },
    {
        id: 2164260963,
        label: 'Fenster > Arbeitsbereich > Automatisierung',
        placement: 'MenuBar',
        name: 'Automatisierung',
    },
    {
        id: 2164260964,
        label: 'Fenster > Arbeitsbereich > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164260965,
        label: 'Fenster > Arbeitsbereich > Layout',
        placement: 'MenuBar',
        name: 'Layout',
    },
    {
        id: 2164260966,
        label: 'Fenster > Arbeitsbereich > Grundfunktionen',
        placement: 'MenuBar',
        name: 'Grundfunktionen',
    },
    {
        id: 2164260967,
        label: 'Fenster > Arbeitsbereich > Typografie',
        placement: 'MenuBar',
        name: 'Typografie',
    },
    {
        id: 2164260968,
        label: 'Fenster > Arbeitsbereich > Drucken und Proofen',
        placement: 'MenuBar',
        name: 'Drucken und Proofen',
    },
    {
        id: 2164260969,
        label: 'Fenster > Arbeitsbereich > Nachzeichnen',
        placement: 'MenuBar',
        name: 'Nachzeichnen',
    },
    {
        id: 2164260970,
        label: 'Fenster > Arbeitsbereich > Malen',
        placement: 'MenuBar',
        name: 'Malen',
    },
    {
        id: 2164260971,
        label: 'Fenster > Ebenen',
        placement: 'MenuBar',
        name: 'Ebenen',
    },
    {
        id: 2164260974,
        label: 'Bearbeiten > Tastaturbefehle...',
        placement: 'MenuBar',
        name: 'Tastaturbefehle...',
    },
    {
        id: 2164260975,
        label: 'Fenster > Grafikstile',
        placement: 'MenuBar',
        name: 'Grafikstile',
    },
    {
        id: 2164260976,
        label: 'Fenster > Aussehen',
        placement: 'MenuBar',
        name: 'Aussehen',
    },
    {
        id: 2164260982,
        label: 'Fenster > Grafikstil-Bibliotheken > 3D-Effekte',
        placement: 'MenuBar',
        name: '3D-Effekte',
    },
    {
        id: 2164260983,
        label: 'Fenster > Grafikstil-Bibliotheken > Bildeffekte',
        placement: 'MenuBar',
        name: 'Bildeffekte',
    },
    {
        id: 2164260984,
        label: 'Fenster > Grafikstil-Bibliotheken > Kunsteffekte',
        placement: 'MenuBar',
        name: 'Kunsteffekte',
    },
    {
        id: 2164260985,
        label: 'Fenster > Grafikstil-Bibliotheken > Leuchten-Stile',
        placement: 'MenuBar',
        name: 'Leuchten-Stile',
    },
    {
        id: 2164260986,
        label: 'Fenster > Grafikstil-Bibliotheken > Neon-Effekte',
        placement: 'MenuBar',
        name: 'Neon-Effekte',
    },
    {
        id: 2164260987,
        label: 'Fenster > Grafikstil-Bibliotheken > Schaltflächen und Rollover',
        placement: 'MenuBar',
        name: 'Schaltflächen und Rollover',
    },
    {
        id: 2164260988,
        label: 'Fenster > Grafikstil-Bibliotheken > Scribble-Effekte',
        placement: 'MenuBar',
        name: 'Scribble-Effekte',
    },
    {
        id: 2164260989,
        label: 'Fenster > Grafikstil-Bibliotheken > Strukturen',
        placement: 'MenuBar',
        name: 'Strukturen',
    },
    {
        id: 2164260990,
        label: 'Fenster > Grafikstil-Bibliotheken > Texteffekte',
        placement: 'MenuBar',
        name: 'Texteffekte',
    },
    {
        id: 2164260991,
        label: 'Fenster > Grafikstil-Bibliotheken > Vonster-Musterstile',
        placement: 'MenuBar',
        name: 'Vonster-Musterstile',
    },
    {
        id: 2164260992,
        label: 'Fenster > Grafikstil-Bibliotheken > Zusatz für Tropfenpinsel',
        placement: 'MenuBar',
        name: 'Zusatz für Tropfenpinsel',
    },
    {
        id: 2164260993,
        label: 'Fenster > Grafikstil-Bibliotheken > Zusatz',
        placement: 'MenuBar',
        name: 'Zusatz',
    },
    {
        id: 2164260996,
        label: 'Fenster > Grafikstil-Bibliotheken > Andere Bibliothek...',
        placement: 'MenuBar',
        name: 'Andere Bibliothek...',
    },
    {
        id: 2164260997,
        label: 'Ansicht > Intelligente Hilfslinien',
        placement: 'MenuBar',
        name: 'Intelligente Hilfslinien',
    },
    {
        id: 2164260998,
        label: 'Fenster > Symbole',
        placement: 'MenuBar',
        name: 'Symbole',
    },
    {
        id: 2164261000,
        label: 'Fenster > Symbol-Bibliotheken > 3D-Symbole',
        placement: 'MenuBar',
        name: '3D-Symbole',
    },
    {
        id: 2164261001,
        label: 'Fenster > Symbol-Bibliotheken > Blumen',
        placement: 'MenuBar',
        name: 'Blumen',
    },
    {
        id: 2164261002,
        label: 'Fenster > Symbol-Bibliotheken > Blumig Vektorpaket',
        placement: 'MenuBar',
        name: 'Blumig Vektorpaket',
    },
    {
        id: 2164261003,
        label: 'Fenster > Symbol-Bibliotheken > Diagramme',
        placement: 'MenuBar',
        name: 'Diagramme',
    },
    {
        id: 2164261004,
        label: 'Fenster > Symbol-Bibliotheken > Erbstück',
        placement: 'MenuBar',
        name: 'Erbstück',
    },
    {
        id: 2164261005,
        label: 'Fenster > Symbol-Bibliotheken > Feier',
        placement: 'MenuBar',
        name: 'Feier',
    },
    {
        id: 2164261006,
        label: 'Fenster > Symbol-Bibliotheken > Haare und Pelz',
        placement: 'MenuBar',
        name: 'Haare und Pelz',
    },
    {
        id: 2164261007,
        label: 'Fenster > Symbol-Bibliotheken > Hoheitlich Vektorpaket',
        placement: 'MenuBar',
        name: 'Hoheitlich Vektorpaket',
    },
    {
        id: 2164261008,
        label: 'Fenster > Symbol-Bibliotheken > Karten',
        placement: 'MenuBar',
        name: 'Karten',
    },
    {
        id: 2164261009,
        label: 'Fenster > Symbol-Bibliotheken > Kommunikation',
        placement: 'MenuBar',
        name: 'Kommunikation',
    },
    {
        id: 2164261010,
        label: 'Fenster > Symbol-Bibliotheken > Kunststrukturen',
        placement: 'MenuBar',
        name: 'Kunststrukturen',
    },
    {
        id: 2164261011,
        label: 'Fenster > Symbol-Bibliotheken > Leuchten für Bänder',
        placement: 'MenuBar',
        name: 'Leuchten für Bänder',
    },
    {
        id: 2164261012,
        label: 'Fenster > Symbol-Bibliotheken > Leuchten für Flussdiagramme',
        placement: 'MenuBar',
        name: 'Leuchten für Flussdiagramme',
    },
    {
        id: 2164261013,
        label: 'Fenster > Symbol-Bibliotheken > Leuchten für Organigramme',
        placement: 'MenuBar',
        name: 'Leuchten für Organigramme',
    },
    {
        id: 2164261014,
        label: 'Fenster > Symbol-Bibliotheken > Logo-Elemente',
        placement: 'MenuBar',
        name: 'Logo-Elemente',
    },
    {
        id: 2164261015,
        label: 'Fenster > Symbol-Bibliotheken > Mobil',
        placement: 'MenuBar',
        name: 'Mobil',
    },
    {
        id: 2164261016,
        label: 'Fenster > Symbol-Bibliotheken > Mode',
        placement: 'MenuBar',
        name: 'Mode',
    },
    {
        id: 2164261017,
        label: 'Fenster > Symbol-Bibliotheken > Natur',
        placement: 'MenuBar',
        name: 'Natur',
    },
    {
        id: 2164261018,
        label: 'Fenster > Symbol-Bibliotheken > Pfeile',
        placement: 'MenuBar',
        name: 'Pfeile',
    },
    {
        id: 2164261019,
        label: 'Fenster > Symbol-Bibliotheken > Punktmuster Vektorpaket',
        placement: 'MenuBar',
        name: 'Punktmuster Vektorpaket',
    },
    {
        id: 2164261020,
        label: 'Fenster > Symbol-Bibliotheken > Retro',
        placement: 'MenuBar',
        name: 'Retro',
    },
    {
        id: 2164261021,
        label: 'Fenster > Symbol-Bibliotheken > Schmutz Vektorpaket',
        placement: 'MenuBar',
        name: 'Schmutz Vektorpaket',
    },
    {
        id: 2164261022,
        label: 'Fenster > Symbol-Bibliotheken > Sushi',
        placement: 'MenuBar',
        name: 'Sushi',
    },
    {
        id: 2164261023,
        label: 'Fenster > Symbol-Bibliotheken > Tiki',
        placement: 'MenuBar',
        name: 'Tiki',
    },
    {
        id: 2164261024,
        label: 'Fenster > Symbol-Bibliotheken > Verrückte Wissenschaft',
        placement: 'MenuBar',
        name: 'Verrückte Wissenschaft',
    },
    {
        id: 2164261025,
        label: 'Fenster > Symbol-Bibliotheken > Volkskunst',
        placement: 'MenuBar',
        name: 'Volkskunst',
    },
    {
        id: 2164261026,
        label: 'Fenster > Symbol-Bibliotheken > Web-Schaltflächen',
        placement: 'MenuBar',
        name: 'Web-Schaltflächen',
    },
    {
        id: 2164261027,
        label: 'Fenster > Symbol-Bibliotheken > Web-Symbole',
        placement: 'MenuBar',
        name: 'Web-Symbole',
    },
    {
        id: 2164261030,
        label: 'Fenster > Symbol-Bibliotheken > Andere Bibliothek...',
        placement: 'MenuBar',
        name: 'Andere Bibliothek...',
    },
    {
        id: 2164261032,
        label: 'Fenster > Dokumentinformationen',
        placement: 'MenuBar',
        name: 'Dokumentinformationen',
    },
    {
        id: 2164261033,
        label: 'Fenster > Reduzierungsvorschau',
        placement: 'MenuBar',
        name: 'Reduzierungsvorschau',
    },
    {
        id: 2164261034,
        label: 'Fenster > Protokoll',
        placement: 'MenuBar',
        name: 'Protokoll',
    },
    {
        id: 2164261036,
        label: 'Schrift > Glyphen',
        placement: 'MenuBar',
        name: 'Glyphen',
    },
    {
        id: 2164261037,
        label: 'Fenster > Schrift > Glyphen',
        placement: 'MenuBar',
        name: 'Glyphen',
    },
    {
        id: 2164261038,
        label: 'Fenster > Aktionen',
        placement: 'MenuBar',
        name: 'Aktionen',
    },
    {
        id: 2164261040,
        label: 'Fenster > Farbe',
        placement: 'MenuBar',
        name: 'Farbe',
    },
    {
        id: 2164261042,
        label: 'Fenster > Verlauf',
        placement: 'MenuBar',
        name: 'Verlauf',
    },
    {
        id: 2164261043,
        label: 'Fenster > Kontur',
        placement: 'MenuBar',
        name: 'Kontur',
    },
    {
        id: 2164261044,
        label: 'Ansicht > Verlaufsoptimierer ausblenden',
        placement: 'MenuBar',
        name: 'Verlaufsoptimierer ausblenden',
    },
    {
        id: 2164261045,
        label: 'Objekt > Pfad > Pfadrichtung umkehren',
        placement: 'MenuBar',
        name: 'Pfadrichtung umkehren',
    },
    {
        id: 2164261046,
        label: 'Fenster > Transparenz',
        placement: 'MenuBar',
        name: 'Transparenz',
    },
    {
        id: 2164261047,
        label: 'Ansicht > Transparenzraster einblenden',
        placement: 'MenuBar',
        name: 'Transparenzraster einblenden',
    },
    {
        id: 2164261048,
        label: 'Fenster > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 2164261050,
        label: 'Objekt > Angleichen > Erstellen',
        placement: 'MenuBar',
        name: 'Erstellen',
    },
    {
        id: 2164261051,
        label: 'Objekt > Angleichen > Zurückwandeln',
        placement: 'MenuBar',
        name: 'Zurückwandeln',
    },
    {
        id: 2164261053,
        label: 'Objekt > Angleichen > Angleichung-Optionen...',
        placement: 'MenuBar',
        name: 'Angleichung-Optionen...',
    },
    {
        id: 2164261055,
        label: 'Objekt > Angleichen > Umwandeln',
        placement: 'MenuBar',
        name: 'Umwandeln',
    },
    {
        id: 2164261057,
        label: 'Objekt > Angleichen > Achse ersetzen',
        placement: 'MenuBar',
        name: 'Achse ersetzen',
    },
    {
        id: 2164261058,
        label: 'Objekt > Angleichen > Achse umkehren',
        placement: 'MenuBar',
        name: 'Achse umkehren',
    },
    {
        id: 2164261059,
        label: 'Objekt > Angleichen > Farbrichtung umkehren',
        placement: 'MenuBar',
        name: 'Farbrichtung umkehren',
    },
    {
        id: 2164261061,
        label: 'Ansicht > Slices einblenden',
        placement: 'MenuBar',
        name: 'Slices einblenden',
    },
    {
        id: 2164261062,
        label: 'Ansicht > Slices fixieren',
        placement: 'MenuBar',
        name: 'Slices fixieren',
    },
    {
        id: 2164261065,
        label: 'Objekt > Slice > Erstellen',
        placement: 'MenuBar',
        name: 'Erstellen',
    },
    {
        id: 2164261066,
        label: 'Objekt > Slice > Zurückwandeln',
        placement: 'MenuBar',
        name: 'Zurückwandeln',
    },
    {
        id: 2164261068,
        label: 'Objekt > Slice > Aus Hilfslinien erstellen',
        placement: 'MenuBar',
        name: 'Aus Hilfslinien erstellen',
    },
    {
        id: 2164261069,
        label: 'Objekt > Slice > Aus Auswahl erstellen',
        placement: 'MenuBar',
        name: 'Aus Auswahl erstellen',
    },
    {
        id: 2164261071,
        label: 'Objekt > Slice > Slice duplizieren',
        placement: 'MenuBar',
        name: 'Slice duplizieren',
    },
    {
        id: 2164261072,
        label: 'Objekt > Slice > Slices kombinieren',
        placement: 'MenuBar',
        name: 'Slices kombinieren',
    },
    {
        id: 2164261073,
        label: 'Objekt > Slice > Slices unterteilen...',
        placement: 'MenuBar',
        name: 'Slices unterteilen...',
    },
    {
        id: 2164261074,
        label: 'Objekt > Slice > Alle löschen',
        placement: 'MenuBar',
        name: 'Alle löschen',
    },
    {
        id: 2164261076,
        label: 'Objekt > Slice > Slice-Optionen...',
        placement: 'MenuBar',
        name: 'Slice-Optionen...',
    },
    {
        id: 2164261078,
        label: 'Objekt > Slice > Ganze Zeichenfläche exportieren',
        placement: 'MenuBar',
        name: 'Ganze Zeichenfläche exportieren',
    },
    {
        id: 2164261080,
        label: 'Bearbeiten > Farben bearbeiten > Vorne -> Hinten angleichen',
        placement: 'MenuBar',
        name: 'Vorne -> Hinten angleichen',
    },
    {
        id: 2164261081,
        label: 'Bearbeiten > Farben bearbeiten > Horizontal angleichen',
        placement: 'MenuBar',
        name: 'Horizontal angleichen',
    },
    {
        id: 2164261082,
        label: 'Bearbeiten > Farben bearbeiten > Vertikal angleichen',
        placement: 'MenuBar',
        name: 'Vertikal angleichen',
    },
    {
        id: 2164261083,
        label: 'Bearbeiten > Farben bearbeiten > Farben invertieren',
        placement: 'MenuBar',
        name: 'Farben invertieren',
    },
    {
        id: 2164261084,
        label: 'Bearbeiten > Farben bearbeiten > In Graustufen konvertieren',
        placement: 'MenuBar',
        name: 'In Graustufen konvertieren',
    },
    {
        id: 2164261085,
        label: 'Bearbeiten > Farben bearbeiten > In CMYK konvertieren',
        placement: 'MenuBar',
        name: 'In CMYK konvertieren',
    },
    {
        id: 2164261086,
        label: 'Bearbeiten > Farben bearbeiten > In RGB konvertieren',
        placement: 'MenuBar',
        name: 'In RGB konvertieren',
    },
    {
        id: 2164261087,
        label: 'Effekt > Illustrator-Effekte',
        placement: 'MenuBar',
        name: 'Illustrator-Effekte',
    },
    {
        id: 2164261090,
        label: 'Effekt > Pathfinder > Hinzufügen',
        placement: 'MenuBar',
        name: 'Hinzufügen',
    },
    {
        id: 2164261091,
        label: 'Effekt > Pathfinder > Schnittmenge bilden',
        placement: 'MenuBar',
        name: 'Schnittmenge bilden',
    },
    {
        id: 2164261092,
        label: 'Effekt > Pathfinder > Schnittmenge entfernen',
        placement: 'MenuBar',
        name: 'Schnittmenge entfernen',
    },
    {
        id: 2164261093,
        label: 'Effekt > Pathfinder > Subtrahieren',
        placement: 'MenuBar',
        name: 'Subtrahieren',
    },
    {
        id: 2164261094,
        label: 'Effekt > Pathfinder > Hinteres Objekt abziehen',
        placement: 'MenuBar',
        name: 'Hinteres Objekt abziehen',
    },
    {
        id: 2164261095,
        label: 'Effekt > Pathfinder > Unterteilen',
        placement: 'MenuBar',
        name: 'Unterteilen',
    },
    {
        id: 2164261096,
        label: 'Effekt > Pathfinder > Überlappungsbereich entfernen',
        placement: 'MenuBar',
        name: 'Überlappungsbereich entfernen',
    },
    {
        id: 2164261097,
        label: 'Effekt > Pathfinder > Verdeckte Fläche entfernen',
        placement: 'MenuBar',
        name: 'Verdeckte Fläche entfernen',
    },
    {
        id: 2164261098,
        label: 'Effekt > Pathfinder > Schnittmengenfläche',
        placement: 'MenuBar',
        name: 'Schnittmengenfläche',
    },
    {
        id: 2164261099,
        label: 'Effekt > Pathfinder > Kontur aufteilen',
        placement: 'MenuBar',
        name: 'Kontur aufteilen',
    },
    {
        id: 2164261100,
        label: 'Effekt > Pathfinder > Hart mischen',
        placement: 'MenuBar',
        name: 'Hart mischen',
    },
    {
        id: 2164261101,
        label: 'Effekt > Pathfinder > Weich mischen...',
        placement: 'MenuBar',
        name: 'Weich mischen...',
    },
    {
        id: 2164261102,
        label: 'Effekt > Pathfinder > Überfüllen...',
        placement: 'MenuBar',
        name: 'Überfüllen...',
    },
    {
        id: 2164261103,
        label: 'Auswahl > Erneut auswählen',
        placement: 'MenuBar',
        name: 'Erneut auswählen',
    },
    {
        id: 2164261105,
        label: 'Auswahl > Gleich > Formen und Text',
        placement: 'MenuBar',
        name: 'Formen und Text',
    },
    {
        id: 2164261106,
        label: 'Auswahl > Gleich > Text',
        placement: 'MenuBar',
        name: 'Text',
    },
    {
        id: 2164261108,
        label: 'Auswahl > Gleich > Flächenfarbe',
        placement: 'MenuBar',
        name: 'Flächenfarbe',
    },
    {
        id: 2164261109,
        label: 'Auswahl > Gleich > Grafikstil',
        placement: 'MenuBar',
        name: 'Grafikstil',
    },
    {
        id: 2164261110,
        label: 'Auswahl > Gleich > Fläche und Kontur',
        placement: 'MenuBar',
        name: 'Fläche und Kontur',
    },
    {
        id: 2164261111,
        label: 'Auswahl > Gleich > Konturfarbe',
        placement: 'MenuBar',
        name: 'Konturfarbe',
    },
    {
        id: 2164261112,
        label: 'Auswahl > Gleich > Konturstärke',
        placement: 'MenuBar',
        name: 'Konturstärke',
    },
    {
        id: 2164261113,
        label: 'Auswahl > Gleich > Füllmethode',
        placement: 'MenuBar',
        name: 'Füllmethode',
    },
    {
        id: 2164261114,
        label: 'Auswahl > Gleich > Deckkraft',
        placement: 'MenuBar',
        name: 'Deckkraft',
    },
    {
        id: 2164261115,
        label: 'Auswahl > Gleich > Form',
        placement: 'MenuBar',
        name: 'Form',
    },
    {
        id: 2164261116,
        label: 'Auswahl > Gleich > Symbolinstanz',
        placement: 'MenuBar',
        name: 'Symbolinstanz',
    },
    {
        id: 2164261117,
        label: 'Auswahl > Gleich > Verknüpfungsblockreihen',
        placement: 'MenuBar',
        name: 'Verknüpfungsblockreihen',
    },
    {
        id: 2164261118,
        label: 'Auswahl > Gleich > Aussehen',
        placement: 'MenuBar',
        name: 'Aussehen',
    },
    {
        id: 2164261119,
        label: 'Auswahl > Gleich > Aussehensattribute',
        placement: 'MenuBar',
        name: 'Aussehensattribute',
    },
    {
        id: 2164261120,
        label: 'Auswahl > Gleich > Textflächenfarbe',
        placement: 'MenuBar',
        name: 'Textflächenfarbe',
    },
    {
        id: 2164261121,
        label: 'Auswahl > Gleich > Textkonturfarbe',
        placement: 'MenuBar',
        name: 'Textkonturfarbe',
    },
    {
        id: 2164261122,
        label: 'Auswahl > Gleich > Textflächen- und -konturfarbe',
        placement: 'MenuBar',
        name: 'Textflächen- und -konturfarbe',
    },
    {
        id: 2164261123,
        label: 'Auswahl > Gleich > Schriftgrad',
        placement: 'MenuBar',
        name: 'Schriftgrad',
    },
    {
        id: 2164261124,
        label: 'Auswahl > Gleich > Schriftfamilie',
        placement: 'MenuBar',
        name: 'Schriftfamilie',
    },
    {
        id: 2164261125,
        label: 'Auswahl > Gleich > Schriftfamilie und -schnitt',
        placement: 'MenuBar',
        name: 'Schriftfamilie und -schnitt',
    },
    {
        id: 2164261126,
        label: 'Auswahl > Gleich > Schriftfamilie, -schnitt und -grad',
        placement: 'MenuBar',
        name: 'Schriftfamilie, -schnitt und -grad',
    },
    {
        id: 2164261127,
        label: 'Auswahl > Objekt > Einzelne Ankerpunkte',
        placement: 'MenuBar',
        name: 'Einzelne Ankerpunkte',
    },
    {
        id: 2164261129,
        label: 'Auswahl > Objekt > Alle Textobjekte',
        placement: 'MenuBar',
        name: 'Alle Textobjekte',
    },
    {
        id: 2164261130,
        label: 'Auswahl > Objekt > Punkttextobjekte',
        placement: 'MenuBar',
        name: 'Punkttextobjekte',
    },
    {
        id: 2164261131,
        label: 'Auswahl > Objekt > Flächentextobjekte',
        placement: 'MenuBar',
        name: 'Flächentextobjekte',
    },
    {
        id: 2164261132,
        label: 'Effekt > Schnittmarken',
        placement: 'MenuBar',
        name: 'Schnittmarken',
    },
    {
        id: 2164261133,
        label: 'Objekt > Schnittmarken erstellen',
        placement: 'MenuBar',
        name: 'Schnittmarken erstellen',
    },
    {
        id: 2164261134,
        label: 'Objekt > Umwandeln...',
        placement: 'MenuBar',
        name: 'Umwandeln...',
    },
    {
        id: 2164261136,
        label: 'Effekt > 3D und Materialien > Extrudieren und abgeflachte Kante...',
        placement: 'MenuBar',
        name: 'Extrudieren und abgeflachte Kante...',
    },
    {
        id: 2164261137,
        label: 'Effekt > 3D und Materialien > Kreiseln...',
        placement: 'MenuBar',
        name: 'Kreiseln...',
    },
    {
        id: 2164261138,
        label: 'Effekt > 3D und Materialien > Aufblasen...',
        placement: 'MenuBar',
        name: 'Aufblasen...',
    },
    {
        id: 2164261139,
        label: 'Effekt > 3D und Materialien > Drehen...',
        placement: 'MenuBar',
        name: 'Drehen...',
    },
    {
        id: 2164261140,
        label: 'Effekt > 3D und Materialien > Materialien...',
        placement: 'MenuBar',
        name: 'Materialien...',
    },
    {
        id: 2164261142,
        label: 'Effekt > 3D und Materialien > 3D (klassisch) > Extrudieren und abgeflachte Kante (klassisch)...',
        placement: 'MenuBar',
        name: 'Extrudieren und abgeflachte Kante (klassisch)...',
    },
    {
        id: 2164261143,
        label: 'Effekt > 3D und Materialien > 3D (klassisch) > Kreiseln (klassisch)...',
        placement: 'MenuBar',
        name: 'Kreiseln (klassisch)...',
    },
    {
        id: 2164261144,
        label: 'Effekt > 3D und Materialien > 3D (klassisch) > Drehen (klassisch)...',
        placement: 'MenuBar',
        name: 'Drehen (klassisch)...',
    },
    {
        id: 2164261145,
        label: 'Fenster > SVG-Interaktivität',
        placement: 'MenuBar',
        name: 'SVG-Interaktivität',
    },
    {
        id: 2164261146,
        label: 'Illustrator > Voreinstellungen > Leistung...',
        placement: 'MenuBar',
        name: 'Leistung...',
    },
    {
        id: 2164261147,
        label: 'Illustrator > Voreinstellungen > Dateihandhabung...',
        placement: 'MenuBar',
        name: 'Dateihandhabung...',
    },
    {
        id: 2164261148,
        label: 'Illustrator > Voreinstellungen > Zwischenablageoptionen...',
        placement: 'MenuBar',
        name: 'Zwischenablageoptionen...',
    },
    {
        id: 2164261149,
        label: 'Illustrator > Voreinstellungen > Aussehen von Schwarz...',
        placement: 'MenuBar',
        name: 'Aussehen von Schwarz...',
    },
    {
        id: 2164261150,
        label: 'Illustrator > Voreinstellungen > Geräte...',
        placement: 'MenuBar',
        name: 'Geräte...',
    },
    {
        id: 2164261152,
        label: 'Fenster > Werkzeugleisten > Einfach',
        placement: 'MenuBar',
        name: 'Einfach',
    },
    {
        id: 2164261153,
        label: 'Fenster > Werkzeugleisten > Erweitert',
        placement: 'MenuBar',
        name: 'Erweitert',
    },
    {
        id: 2164261154,
        label: 'Fenster > Werkzeugleisten > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261156,
        label: 'Fenster > Werkzeugleisten > Neue Werkzeugleiste...',
        placement: 'MenuBar',
        name: 'Neue Werkzeugleiste...',
    },
    {
        id: 2164261157,
        label: 'Fenster > Werkzeugleisten > Werkzeugleisten verwalten...',
        placement: 'MenuBar',
        name: 'Werkzeugleisten verwalten...',
    },
    {
        id: 2164261158,
        label: 'Fenster > Pinsel',
        placement: 'MenuBar',
        name: 'Pinsel',
    },
    {
        id: 2164261159,
        label: 'Auswahl > Objekt > Pinselkonturen',
        placement: 'MenuBar',
        name: 'Pinselkonturen',
    },
    {
        id: 2164261162,
        label: 'Fenster > Pinsel-Bibliotheken > Bildpinsel > Bildpinselbibliothek',
        placement: 'MenuBar',
        name: 'Bildpinselbibliothek',
    },
    {
        id: 2164261164,
        label: 'Fenster > Pinsel-Bibliotheken > Borstenpinsel > Borstenpinselbibliothek',
        placement: 'MenuBar',
        name: 'Borstenpinselbibliothek',
    },
    {
        id: 2164261166,
        label: 'Fenster > Pinsel-Bibliotheken > Dekorativ > Dekorativ_Banner und Siegel',
        placement: 'MenuBar',
        name: 'Dekorativ_Banner und Siegel',
    },
    {
        id: 2164261167,
        label: 'Fenster > Pinsel-Bibliotheken > Dekorativ > Dekorativ_Streuung',
        placement: 'MenuBar',
        name: 'Dekorativ_Streuung',
    },
    {
        id: 2164261168,
        label: 'Fenster > Pinsel-Bibliotheken > Dekorativ > Dekorativ_Texttrennlinien',
        placement: 'MenuBar',
        name: 'Dekorativ_Texttrennlinien',
    },
    {
        id: 2164261169,
        label: 'Fenster > Pinsel-Bibliotheken > Dekorativ > Satz elegant geschweifte und Blumenpinsel',
        placement: 'MenuBar',
        name: 'Satz elegant geschweifte und Blumenpinsel',
    },
    {
        id: 2164261171,
        label: 'Fenster > Pinsel-Bibliotheken > Künstlerisch > Kalligrafisch',
        placement: 'MenuBar',
        name: 'Kalligrafisch',
    },
    {
        id: 2164261172,
        label: 'Fenster > Pinsel-Bibliotheken > Künstlerisch > Künstl._Kr.Koh.Bleist',
        placement: 'MenuBar',
        name: 'Künstl._Kr.Koh.Bleist',
    },
    {
        id: 2164261173,
        label: 'Fenster > Pinsel-Bibliotheken > Künstlerisch > Künstlerisch_Aquarell',
        placement: 'MenuBar',
        name: 'Künstlerisch_Aquarell',
    },
    {
        id: 2164261174,
        label: 'Fenster > Pinsel-Bibliotheken > Künstlerisch > Künstlerisch_Federkiel',
        placement: 'MenuBar',
        name: 'Künstlerisch_Federkiel',
    },
    {
        id: 2164261175,
        label: 'Fenster > Pinsel-Bibliotheken > Künstlerisch > Künstlerisch_Pinsel',
        placement: 'MenuBar',
        name: 'Künstlerisch_Pinsel',
    },
    {
        id: 2164261176,
        label: 'Fenster > Pinsel-Bibliotheken > Künstlerisch > Künstlerisch_Tinte',
        placement: 'MenuBar',
        name: 'Künstlerisch_Tinte',
    },
    {
        id: 2164261178,
        label: 'Fenster > Pinsel-Bibliotheken > Pfeile > Musterpfeile',
        placement: 'MenuBar',
        name: 'Musterpfeile',
    },
    {
        id: 2164261179,
        label: 'Fenster > Pinsel-Bibliotheken > Pfeile > Pfeile_Spezial',
        placement: 'MenuBar',
        name: 'Pfeile_Spezial',
    },
    {
        id: 2164261180,
        label: 'Fenster > Pinsel-Bibliotheken > Pfeile > Pfeile_Standard',
        placement: 'MenuBar',
        name: 'Pfeile_Standard',
    },
    {
        id: 2164261182,
        label: 'Fenster > Pinsel-Bibliotheken > Umrandungen > Umrandungen_Dekorativ',
        placement: 'MenuBar',
        name: 'Umrandungen_Dekorativ',
    },
    {
        id: 2164261183,
        label: 'Fenster > Pinsel-Bibliotheken > Umrandungen > Umrandungen_Dies und das',
        placement: 'MenuBar',
        name: 'Umrandungen_Dies und das',
    },
    {
        id: 2164261184,
        label: 'Fenster > Pinsel-Bibliotheken > Umrandungen > Umrandungen_Geometrisch',
        placement: 'MenuBar',
        name: 'Umrandungen_Geometrisch',
    },
    {
        id: 2164261185,
        label: 'Fenster > Pinsel-Bibliotheken > Umrandungen > Umrandungen_Gestrichelt',
        placement: 'MenuBar',
        name: 'Umrandungen_Gestrichelt',
    },
    {
        id: 2164261186,
        label: 'Fenster > Pinsel-Bibliotheken > Umrandungen > Umrandungen_Linien',
        placement: 'MenuBar',
        name: 'Umrandungen_Linien',
    },
    {
        id: 2164261187,
        label: 'Fenster > Pinsel-Bibliotheken > Umrandungen > Umrandungen_Rahmen',
        placement: 'MenuBar',
        name: 'Umrandungen_Rahmen',
    },
    {
        id: 2164261188,
        label: 'Fenster > Pinsel-Bibliotheken > Umrandungen > Umrandungen_Volkskunst',
        placement: 'MenuBar',
        name: 'Umrandungen_Volkskunst',
    },
    {
        id: 2164261190,
        label: 'Fenster > Pinsel-Bibliotheken > Vektorpakete > Handgemalte Pinsel Vektorpaket',
        placement: 'MenuBar',
        name: 'Handgemalte Pinsel Vektorpaket',
    },
    {
        id: 2164261191,
        label: 'Fenster > Pinsel-Bibliotheken > Vektorpakete > Schmutzpinsel Vektorpaket',
        placement: 'MenuBar',
        name: 'Schmutzpinsel Vektorpaket',
    },
    {
        id: 2164261193,
        label: 'Fenster > Pinsel-Bibliotheken > Wacom 6D-Pinsel > 6D-Grafik Zeichenstiftpinsel',
        placement: 'MenuBar',
        name: '6D-Grafik Zeichenstiftpinsel',
    },
    {
        id: 2164261196,
        label: 'Fenster > Pinsel-Bibliotheken > Andere Bibliothek...',
        placement: 'MenuBar',
        name: 'Andere Bibliothek...',
    },
    {
        id: 2164261197,
        label: 'Fenster > Pathfinder',
        placement: 'MenuBar',
        name: 'Pathfinder',
    },
    {
        id: 2164261198,
        label: 'Fenster > Variablen',
        placement: 'MenuBar',
        name: 'Variablen',
    },
    {
        id: 2164261200,
        label: 'Fenster > Zauberstab',
        placement: 'MenuBar',
        name: 'Zauberstab',
    },
    {
        id: 2164261201,
        label: 'Objekt > Pfad > Darunter liegende Objekte aufteilen',
        placement: 'MenuBar',
        name: 'Darunter liegende Objekte aufteilen',
    },
    {
        id: 2164261202,
        label: 'Auswahl > Objekt > Borstenpinselstriche',
        placement: 'MenuBar',
        name: 'Borstenpinselstriche',
    },
    {
        id: 2164261205,
        label: 'Objekt > Transformieren > Begrenzungsrahmen zurücksetzen',
        placement: 'MenuBar',
        name: 'Begrenzungsrahmen zurücksetzen',
    },
    {
        id: 2164261206,
        label: 'Ansicht > Begrenzungsrahmen ausblenden',
        placement: 'MenuBar',
        name: 'Begrenzungsrahmen ausblenden',
    },
    {
        id: 2164261207,
        label: 'Objekt > Pfad > Vereinfachen...',
        placement: 'MenuBar',
        name: 'Vereinfachen...',
    },
    {
        id: 2164261208,
        label: 'Objekt > Pfad > Glätten...',
        placement: 'MenuBar',
        name: 'Glätten...',
    },
    {
        id: 2164261209,
        label: 'Fenster > Farbfelder',
        placement: 'MenuBar',
        name: 'Farbfelder',
    },
    {
        id: 2164261212,
        label: 'Fenster > Musteroptionen',
        placement: 'MenuBar',
        name: 'Musteroptionen',
    },
    {
        id: 2164261213,
        label: 'Fenster > Muster generieren (Beta)',
        placement: 'MenuBar',
        name: 'Muster generieren (Beta)',
    },
    {
        id: 2164261215,
        label: 'Objekt > Muster > Erstellen',
        placement: 'MenuBar',
        name: 'Erstellen',
    },
    {
        id: 2164261217,
        label: 'Objekt > Muster > Muster bearbeiten',
        placement: 'MenuBar',
        name: 'Muster bearbeiten',
    },
    {
        id: 2164261218,
        label: 'Objekt > Muster > Farbe für Musterelement-Kante',
        placement: 'MenuBar',
        name: 'Farbe für Musterelement-Kante',
    },
    {
        id: 2164261220,
        label: 'Objekt > Muster > Muster generieren (Beta)',
        placement: 'MenuBar',
        name: 'Muster generieren (Beta)',
    },
    {
        id: 2164261221,
        label: 'Fenster > Farbfeldbibliotheken > Desert',
        placement: 'MenuBar',
        name: 'Desert',
    },
    {
        id: 2164261222,
        label: 'Fenster > Farbfeldbibliotheken > Erdfarben',
        placement: 'MenuBar',
        name: 'Erdfarben',
    },
    {
        id: 2164261224,
        label: 'Fenster > Farbfeldbibliotheken > Farbeigenschaften > Dunkel',
        placement: 'MenuBar',
        name: 'Dunkel',
    },
    {
        id: 2164261225,
        label: 'Fenster > Farbfeldbibliotheken > Farbeigenschaften > Gesättigt',
        placement: 'MenuBar',
        name: 'Gesättigt',
    },
    {
        id: 2164261226,
        label: 'Fenster > Farbfeldbibliotheken > Farbeigenschaften > Hell',
        placement: 'MenuBar',
        name: 'Hell',
    },
    {
        id: 2164261227,
        label: 'Fenster > Farbfeldbibliotheken > Farbeigenschaften > Kalt',
        placement: 'MenuBar',
        name: 'Kalt',
    },
    {
        id: 2164261228,
        label: 'Fenster > Farbfeldbibliotheken > Farbeigenschaften > Leuchtend',
        placement: 'MenuBar',
        name: 'Leuchtend',
    },
    {
        id: 2164261229,
        label: 'Fenster > Farbfeldbibliotheken > Farbeigenschaften > Ungesättigt',
        placement: 'MenuBar',
        name: 'Ungesättigt',
    },
    {
        id: 2164261230,
        label: 'Fenster > Farbfeldbibliotheken > Farbeigenschaften > Warm',
        placement: 'MenuBar',
        name: 'Warm',
    },
    {
        id: 2164261231,
        label: 'Fenster > Farbfeldbibliotheken > Farbeigenschaften > Weich',
        placement: 'MenuBar',
        name: 'Weich',
    },
    {
        id: 2164261233,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > ANPA Color',
        placement: 'MenuBar',
        name: 'ANPA Color',
    },
    {
        id: 2164261234,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > DIC Color Guide',
        placement: 'MenuBar',
        name: 'DIC Color Guide',
    },
    {
        id: 2164261235,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > FOCOLTONE',
        placement: 'MenuBar',
        name: 'FOCOLTONE',
    },
    {
        id: 2164261236,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > HKS E Process',
        placement: 'MenuBar',
        name: 'HKS E Process',
    },
    {
        id: 2164261237,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > HKS E',
        placement: 'MenuBar',
        name: 'HKS E',
    },
    {
        id: 2164261238,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > HKS K Process',
        placement: 'MenuBar',
        name: 'HKS K Process',
    },
    {
        id: 2164261239,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > HKS K',
        placement: 'MenuBar',
        name: 'HKS K',
    },
    {
        id: 2164261240,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > HKS N Process',
        placement: 'MenuBar',
        name: 'HKS N Process',
    },
    {
        id: 2164261241,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > HKS N',
        placement: 'MenuBar',
        name: 'HKS N',
    },
    {
        id: 2164261242,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > HKS Z Process',
        placement: 'MenuBar',
        name: 'HKS Z Process',
    },
    {
        id: 2164261243,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > HKS Z',
        placement: 'MenuBar',
        name: 'HKS Z',
    },
    {
        id: 2164261244,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > TOYO 94 COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO 94 COLOR FINDER',
    },
    {
        id: 2164261245,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > TOYO COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO COLOR FINDER',
    },
    {
        id: 2164261246,
        label: 'Fenster > Farbfeldbibliotheken > Farbtafeln > TRUMATCH',
        placement: 'MenuBar',
        name: 'TRUMATCH',
    },
    {
        id: 2164261247,
        label: 'Fenster > Farbfeldbibliotheken > Feier',
        placement: 'MenuBar',
        name: 'Feier',
    },
    {
        id: 2164261248,
        label: 'Fenster > Farbfeldbibliotheken > Fruits and Vegetables',
        placement: 'MenuBar',
        name: 'Fruits and Vegetables',
    },
    {
        id: 2164261249,
        label: 'Fenster > Farbfeldbibliotheken > Hauttöne',
        placement: 'MenuBar',
        name: 'Hauttöne',
    },
    {
        id: 2164261251,
        label: 'Fenster > Farbfeldbibliotheken > Kunstgeschichte > Altertum',
        placement: 'MenuBar',
        name: 'Altertum',
    },
    {
        id: 2164261252,
        label: 'Fenster > Farbfeldbibliotheken > Kunstgeschichte > Barock',
        placement: 'MenuBar',
        name: 'Barock',
    },
    {
        id: 2164261253,
        label: 'Fenster > Farbfeldbibliotheken > Kunstgeschichte > Impressionismus',
        placement: 'MenuBar',
        name: 'Impressionismus',
    },
    {
        id: 2164261254,
        label: 'Fenster > Farbfeldbibliotheken > Kunstgeschichte > Mittelalter',
        placement: 'MenuBar',
        name: 'Mittelalter',
    },
    {
        id: 2164261255,
        label: 'Fenster > Farbfeldbibliotheken > Kunstgeschichte > Pop-Art',
        placement: 'MenuBar',
        name: 'Pop-Art',
    },
    {
        id: 2164261256,
        label: 'Fenster > Farbfeldbibliotheken > Kunstgeschichte > Prähistorisch',
        placement: 'MenuBar',
        name: 'Prähistorisch',
    },
    {
        id: 2164261257,
        label: 'Fenster > Farbfeldbibliotheken > Kunstgeschichte > Renaissance',
        placement: 'MenuBar',
        name: 'Renaissance',
    },
    {
        id: 2164261258,
        label: 'Fenster > Farbfeldbibliotheken > Kunstgeschichte > Russische Plakatkunst',
        placement: 'MenuBar',
        name: 'Russische Plakatkunst',
    },
    {
        id: 2164261260,
        label: 'Fenster > Farbfeldbibliotheken > Lebensmittel > Eis',
        placement: 'MenuBar',
        name: 'Eis',
    },
    {
        id: 2164261261,
        label: 'Fenster > Farbfeldbibliotheken > Lebensmittel > Gemüse',
        placement: 'MenuBar',
        name: 'Gemüse',
    },
    {
        id: 2164261262,
        label: 'Fenster > Farbfeldbibliotheken > Lebensmittel > Getränke',
        placement: 'MenuBar',
        name: 'Getränke',
    },
    {
        id: 2164261263,
        label: 'Fenster > Farbfeldbibliotheken > Lebensmittel > Obst',
        placement: 'MenuBar',
        name: 'Obst',
    },
    {
        id: 2164261264,
        label: 'Fenster > Farbfeldbibliotheken > Lebensmittel > Süßigkeiten',
        placement: 'MenuBar',
        name: 'Süßigkeiten',
    },
    {
        id: 2164261265,
        label: 'Fenster > Farbfeldbibliotheken > Metall',
        placement: 'MenuBar',
        name: 'Metall',
    },
    {
        id: 2164261266,
        label: 'Fenster > Farbfeldbibliotheken > Mobile and Devices',
        placement: 'MenuBar',
        name: 'Mobile and Devices',
    },
    {
        id: 2164261269,
        label: 'Fenster > Farbfeldbibliotheken > Muster > Dekorativ > Dekoratives Erbe',
        placement: 'MenuBar',
        name: 'Dekoratives Erbe',
    },
    {
        id: 2164261270,
        label: 'Fenster > Farbfeldbibliotheken > Muster > Dekorativ > Vonster-Muster',
        placement: 'MenuBar',
        name: 'Vonster-Muster',
    },
    {
        id: 2164261272,
        label: 'Fenster > Farbfeldbibliotheken > Muster > Einfache Grafiken > Einfache Grafiken_Linien',
        placement: 'MenuBar',
        name: 'Einfache Grafiken_Linien',
    },
    {
        id: 2164261273,
        label: 'Fenster > Farbfeldbibliotheken > Muster > Einfache Grafiken > Einfache Grafiken_Muster2',
        placement: 'MenuBar',
        name: 'Einfache Grafiken_Muster2',
    },
    {
        id: 2164261274,
        label: 'Fenster > Farbfeldbibliotheken > Muster > Einfache Grafiken > Einfache Grafiken_Strukturen',
        placement: 'MenuBar',
        name: 'Einfache Grafiken_Strukturen',
    },
    {
        id: 2164261276,
        label: 'Fenster > Farbfeldbibliotheken > Muster > Natur > Natur_Laub',
        placement: 'MenuBar',
        name: 'Natur_Laub',
    },
    {
        id: 2164261277,
        label: 'Fenster > Farbfeldbibliotheken > Muster > Natur > Natur_Tierhäute',
        placement: 'MenuBar',
        name: 'Natur_Tierhäute',
    },
    {
        id: 2164261279,
        label: 'Fenster > Farbfeldbibliotheken > Natur > Blumen',
        placement: 'MenuBar',
        name: 'Blumen',
    },
    {
        id: 2164261280,
        label: 'Fenster > Farbfeldbibliotheken > Natur > Jahreszeiten',
        placement: 'MenuBar',
        name: 'Jahreszeiten',
    },
    {
        id: 2164261281,
        label: 'Fenster > Farbfeldbibliotheken > Natur > Landschaft',
        placement: 'MenuBar',
        name: 'Landschaft',
    },
    {
        id: 2164261282,
        label: 'Fenster > Farbfeldbibliotheken > Natur > Laub',
        placement: 'MenuBar',
        name: 'Laub',
    },
    {
        id: 2164261283,
        label: 'Fenster > Farbfeldbibliotheken > Natur > Steine und Ziegel',
        placement: 'MenuBar',
        name: 'Steine und Ziegel',
    },
    {
        id: 2164261284,
        label: 'Fenster > Farbfeldbibliotheken > Natur > Strand',
        placement: 'MenuBar',
        name: 'Strand',
    },
    {
        id: 2164261285,
        label: 'Fenster > Farbfeldbibliotheken > Neutral',
        placement: 'MenuBar',
        name: 'Neutral',
    },
    {
        id: 2164261286,
        label: 'Fenster > Farbfeldbibliotheken > Spielzeug',
        placement: 'MenuBar',
        name: 'Spielzeug',
    },
    {
        id: 2164261288,
        label: 'Fenster > Farbfeldbibliotheken > Standard-Farbfelder > Druck',
        placement: 'MenuBar',
        name: 'Druck',
    },
    {
        id: 2164261289,
        label: 'Fenster > Farbfeldbibliotheken > Standard-Farbfelder > Einfaches RGB',
        placement: 'MenuBar',
        name: 'Einfaches RGB',
    },
    {
        id: 2164261290,
        label: 'Fenster > Farbfeldbibliotheken > Standard-Farbfelder > Geräte',
        placement: 'MenuBar',
        name: 'Geräte',
    },
    {
        id: 2164261291,
        label: 'Fenster > Farbfeldbibliotheken > Standard-Farbfelder > Video und Film',
        placement: 'MenuBar',
        name: 'Video und Film',
    },
    {
        id: 2164261292,
        label: 'Fenster > Farbfeldbibliotheken > Standard-Farbfelder > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261293,
        label: 'Fenster > Farbfeldbibliotheken > System (Macintosh)',
        placement: 'MenuBar',
        name: 'System (Macintosh)',
    },
    {
        id: 2164261294,
        label: 'Fenster > Farbfeldbibliotheken > System (Windows)',
        placement: 'MenuBar',
        name: 'System (Windows)',
    },
    {
        id: 2164261295,
        label: 'Fenster > Farbfeldbibliotheken > Textilien',
        placement: 'MenuBar',
        name: 'Textilien',
    },
    {
        id: 2164261296,
        label: 'Fenster > Farbfeldbibliotheken > Unternehmen',
        placement: 'MenuBar',
        name: 'Unternehmen',
    },
    {
        id: 2164261298,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Blendeneffekte',
        placement: 'MenuBar',
        name: 'Blendeneffekte',
    },
    {
        id: 2164261299,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Edelsteine und Juwelen',
        placement: 'MenuBar',
        name: 'Edelsteine und Juwelen',
    },
    {
        id: 2164261300,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Erdfarben',
        placement: 'MenuBar',
        name: 'Erdfarben',
    },
    {
        id: 2164261301,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Farbharmonien',
        placement: 'MenuBar',
        name: 'Farbharmonien',
    },
    {
        id: 2164261302,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Farbkombinationen',
        placement: 'MenuBar',
        name: 'Farbkombinationen',
    },
    {
        id: 2164261303,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Farbtöne und Schattierungen',
        placement: 'MenuBar',
        name: 'Farbtöne und Schattierungen',
    },
    {
        id: 2164261304,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Hauttöne',
        placement: 'MenuBar',
        name: 'Hauttöne',
    },
    {
        id: 2164261305,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Himmel',
        placement: 'MenuBar',
        name: 'Himmel',
    },
    {
        id: 2164261306,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Holz',
        placement: 'MenuBar',
        name: 'Holz',
    },
    {
        id: 2164261307,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Jahreszeiten',
        placement: 'MenuBar',
        name: 'Jahreszeiten',
    },
    {
        id: 2164261308,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Kreisförmig',
        placement: 'MenuBar',
        name: 'Kreisförmig',
    },
    {
        id: 2164261309,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Laub',
        placement: 'MenuBar',
        name: 'Laub',
    },
    {
        id: 2164261310,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Leuchtende Farben',
        placement: 'MenuBar',
        name: 'Leuchtende Farben',
    },
    {
        id: 2164261311,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Metalle',
        placement: 'MenuBar',
        name: 'Metalle',
    },
    {
        id: 2164261312,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Neutrale',
        placement: 'MenuBar',
        name: 'Neutrale',
    },
    {
        id: 2164261313,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Obst und Gemüse',
        placement: 'MenuBar',
        name: 'Obst und Gemüse',
    },
    {
        id: 2164261314,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Pastelle',
        placement: 'MenuBar',
        name: 'Pastelle',
    },
    {
        id: 2164261315,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Spektren',
        placement: 'MenuBar',
        name: 'Spektren',
    },
    {
        id: 2164261316,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Steine und Ziegel',
        placement: 'MenuBar',
        name: 'Steine und Ziegel',
    },
    {
        id: 2164261317,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Vignetten',
        placement: 'MenuBar',
        name: 'Vignetten',
    },
    {
        id: 2164261318,
        label: 'Fenster > Farbfeldbibliotheken > Verläufe > Wasser',
        placement: 'MenuBar',
        name: 'Wasser',
    },
    {
        id: 2164261319,
        label: 'Fenster > Farbfeldbibliotheken > VisiBone2',
        placement: 'MenuBar',
        name: 'VisiBone2',
    },
    {
        id: 2164261320,
        label: 'Fenster > Farbfeldbibliotheken > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261322,
        label: 'Fenster > Farbfeldbibliotheken > Wissenschaftlich > Analog',
        placement: 'MenuBar',
        name: 'Analog',
    },
    {
        id: 2164261323,
        label: 'Fenster > Farbfeldbibliotheken > Wissenschaftlich > Komplementär teilen',
        placement: 'MenuBar',
        name: 'Komplementär teilen',
    },
    {
        id: 2164261324,
        label: 'Fenster > Farbfeldbibliotheken > Wissenschaftlich > Komplementär',
        placement: 'MenuBar',
        name: 'Komplementär',
    },
    {
        id: 2164261325,
        label: 'Fenster > Farbfeldbibliotheken > Wissenschaftlich > Tetrade',
        placement: 'MenuBar',
        name: 'Tetrade',
    },
    {
        id: 2164261326,
        label: 'Fenster > Farbfeldbibliotheken > Wissenschaftlich > Triade',
        placement: 'MenuBar',
        name: 'Triade',
    },
    {
        id: 2164261329,
        label: 'Fenster > Farbfeldbibliotheken > Andere Bibliothek...',
        placement: 'MenuBar',
        name: 'Andere Bibliothek...',
    },
    {
        id: 2164261330,
        label: 'Fenster > Farbhilfe',
        placement: 'MenuBar',
        name: 'Farbhilfe',
    },
    {
        id: 2164261331,
        label: 'Bearbeiten > Farben bearbeiten > Bildmaterial neu färben...',
        placement: 'MenuBar',
        name: 'Bildmaterial neu färben...',
    },
    {
        id: 2164261334,
        label: 'Bearbeiten > Farben bearbeiten > Generative Neufärbung',
        placement: 'MenuBar',
        name: 'Generative Neufärbung',
    },
    {
        id: 2164261336,
        label: 'Bearbeiten > Farben bearbeiten > Mit Vorgabe neu färben > Farbbibliothek...',
        placement: 'MenuBar',
        name: 'Farbbibliothek...',
    },
    {
        id: 2164261337,
        label: 'Bearbeiten > Farben bearbeiten > Mit Vorgabe neu färben > Einfarbig',
        placement: 'MenuBar',
        name: 'Einfarbig',
    },
    {
        id: 2164261338,
        label: 'Bearbeiten > Farben bearbeiten > Mit Vorgabe neu färben > Zweifarbig',
        placement: 'MenuBar',
        name: 'Zweifarbig',
    },
    {
        id: 2164261339,
        label: 'Bearbeiten > Farben bearbeiten > Mit Vorgabe neu färben > Dreifarbig',
        placement: 'MenuBar',
        name: 'Dreifarbig',
    },
    {
        id: 2164261340,
        label: 'Bearbeiten > Farben bearbeiten > Mit Vorgabe neu färben > Farbharmonie',
        placement: 'MenuBar',
        name: 'Farbharmonie',
    },
    {
        id: 2164261341,
        label: 'Fenster > Steuerung',
        placement: 'MenuBar',
        name: 'Steuerung',
    },
    {
        id: 2164261342,
        label: 'Fenster > Kontextbezogene Taskleiste',
        placement: 'MenuBar',
        name: 'Kontextbezogene Taskleiste',
    },
    {
        id: 2164261344,
        label: 'Objekt > Verflechtung > Erstellen',
        placement: 'MenuBar',
        name: 'Erstellen',
    },
    {
        id: 2164261345,
        label: 'Objekt > Verflechtung > Zurückwandeln',
        placement: 'MenuBar',
        name: 'Zurückwandeln',
    },
    {
        id: 2164261346,
        label: 'Objekt > Verflechtung > Bearbeiten',
        placement: 'MenuBar',
        name: 'Bearbeiten',
    },
    {
        id: 2164261347,
        label: 'Fenster > Ausrichten',
        placement: 'MenuBar',
        name: 'Ausrichten',
    },
    {
        id: 2164261349,
        label: 'Objekt > Ausrichten > Horizontal links ausrichten',
        placement: 'MenuBar',
        name: 'Horizontal links ausrichten',
    },
    {
        id: 2164261350,
        label: 'Objekt > Ausrichten > Horizontal zentriert ausrichten',
        placement: 'MenuBar',
        name: 'Horizontal zentriert ausrichten',
    },
    {
        id: 2164261351,
        label: 'Objekt > Ausrichten > Horizontal rechts ausrichten',
        placement: 'MenuBar',
        name: 'Horizontal rechts ausrichten',
    },
    {
        id: 2164261352,
        label: 'Objekt > Ausrichten > Vertikal oben ausrichten',
        placement: 'MenuBar',
        name: 'Vertikal oben ausrichten',
    },
    {
        id: 2164261353,
        label: 'Objekt > Ausrichten > Vertikal zentriert ausrichten',
        placement: 'MenuBar',
        name: 'Vertikal zentriert ausrichten',
    },
    {
        id: 2164261354,
        label: 'Objekt > Ausrichten > Vertikal unten ausrichten',
        placement: 'MenuBar',
        name: 'Vertikal unten ausrichten',
    },
    {
        id: 2164261356,
        label: 'Objekt > Verteilen > Vertikal oben verteilen',
        placement: 'MenuBar',
        name: 'Vertikal oben verteilen',
    },
    {
        id: 2164261357,
        label: 'Objekt > Verteilen > Vertikal zentriert verteilen',
        placement: 'MenuBar',
        name: 'Vertikal zentriert verteilen',
    },
    {
        id: 2164261358,
        label: 'Objekt > Verteilen > Vertikal unten verteilen',
        placement: 'MenuBar',
        name: 'Vertikal unten verteilen',
    },
    {
        id: 2164261359,
        label: 'Objekt > Verteilen > Horizontal links verteilen',
        placement: 'MenuBar',
        name: 'Horizontal links verteilen',
    },
    {
        id: 2164261360,
        label: 'Objekt > Verteilen > Horizontal zentriert verteilen',
        placement: 'MenuBar',
        name: 'Horizontal zentriert verteilen',
    },
    {
        id: 2164261361,
        label: 'Objekt > Verteilen > Horizontal rechts verteilen',
        placement: 'MenuBar',
        name: 'Horizontal rechts verteilen',
    },
    {
        id: 2164261362,
        label: 'Fenster > Transformieren',
        placement: 'MenuBar',
        name: 'Transformieren',
    },
    {
        id: 2164261364,
        label: 'Objekt > Wiederholen > Radial',
        placement: 'MenuBar',
        name: 'Radial',
    },
    {
        id: 2164261365,
        label: 'Objekt > Wiederholen > Raster',
        placement: 'MenuBar',
        name: 'Raster',
    },
    {
        id: 2164261366,
        label: 'Objekt > Wiederholen > Spiegeln',
        placement: 'MenuBar',
        name: 'Spiegeln',
    },
    {
        id: 2164261368,
        label: 'Objekt > Wiederholen > Zurückwandeln',
        placement: 'MenuBar',
        name: 'Zurückwandeln',
    },
    {
        id: 2164261369,
        label: 'Objekt > Wiederholen > Optionen...',
        placement: 'MenuBar',
        name: 'Optionen...',
    },
    {
        id: 2164261371,
        label: 'Objekt > Objekte auf Pfad > Anhängen...',
        placement: 'MenuBar',
        name: 'Anhängen...',
    },
    {
        id: 2164261372,
        label: 'Objekt > Objekte auf Pfad > Optionen...',
        placement: 'MenuBar',
        name: 'Optionen...',
    },
    {
        id: 2164261373,
        label: 'Objekt > Objekte auf Pfad > Erweitern',
        placement: 'MenuBar',
        name: 'Erweitern',
    },
    {
        id: 2164261375,
        label: 'Objekt > Modell > Modellvorschau',
        placement: 'MenuBar',
        name: 'Modellvorschau',
    },
    {
        id: 2164261376,
        label: 'Objekt > Modell > Zurückwandeln',
        placement: 'MenuBar',
        name: 'Zurückwandeln',
    },
    {
        id: 2164261377,
        label: 'Objekt > Modell > Bearbeiten',
        placement: 'MenuBar',
        name: 'Bearbeiten',
    },
    {
        id: 2164261378,
        label: 'Fenster > Attribute',
        placement: 'MenuBar',
        name: 'Attribute',
    },
    {
        id: 2164261379,
        label: 'Schrift > Mehr bei Adobe Fonts...',
        placement: 'MenuBar',
        name: 'Mehr bei Adobe Fonts...',
    },
    {
        id: 2164261380,
        label: 'Schrift > Fehlende Schriftarten auflösen…',
        placement: 'MenuBar',
        name: 'Fehlende Schriftarten auflösen…',
    },
    {
        id: 2164261381,
        label: 'Hilfe > Support-Community',
        placement: 'MenuBar',
        name: 'Support-Community',
    },
    {
        id: 2164261382,
        label: 'Hilfe > Fehlermeldung/Funktionswunsch senden...',
        placement: 'MenuBar',
        name: 'Fehlermeldung/Funktionswunsch senden...',
    },
    {
        id: 2164261384,
        label: 'Objekt > Pixelgenaue Darstellung anwenden',
        placement: 'MenuBar',
        name: 'Pixelgenaue Darstellung anwenden',
    },
    {
        id: 2164261385,
        label: 'Fenster > Schrift > Reflow-Ansicht',
        placement: 'MenuBar',
        name: 'Reflow-Ansicht',
    },
    {
        id: 2164261386,
        label: 'Hilfe > Benutzerrichtlinien für generative KI',
        placement: 'MenuBar',
        name: 'Benutzerrichtlinien für generative KI',
    },
    {
        id: 2164261388,
        label: 'Bearbeiten > Transparenzreduzierungsvorgaben...',
        placement: 'MenuBar',
        name: 'Transparenzreduzierungsvorgaben...',
    },
    {
        id: 2164261390,
        label: 'Objekt > Transparenz reduzieren...',
        placement: 'MenuBar',
        name: 'Transparenz reduzieren...',
    },
    {
        id: 2164261392,
        label: 'Objekt > Form > In Form umwandeln',
        placement: 'MenuBar',
        name: 'In Form umwandeln',
    },
    {
        id: 2164261393,
        label: 'Objekt > Form > Form umwandeln',
        placement: 'MenuBar',
        name: 'Form umwandeln',
    },
    {
        id: 2164261394,
        label: 'Fenster > Modell',
        placement: 'MenuBar',
        name: 'Modell',
    },
    {
        id: 2164261395,
        label: 'Fenster > Generierte Variationen',
        placement: 'MenuBar',
        name: 'Generierte Variationen',
    },
    {
        id: 2164261396,
        label: 'Objekt > Vektorgrafiken generieren (Beta)...',
        placement: 'MenuBar',
        name: 'Vektorgrafiken generieren (Beta)...',
    },
    {
        id: 2164261397,
        label: 'Datei > Vektorgrafiken generieren (Beta)...',
        placement: 'MenuBar',
        name: 'Vektorgrafiken generieren (Beta)...',
    },
    {
        id: 2164261398,
        label: 'Objekt > Generative Formfüllung (Beta)...',
        placement: 'MenuBar',
        name: 'Generative Formfüllung (Beta)...',
    },
    {
        id: 2164261399,
        label: 'Fenster > 3D und Materialien',
        placement: 'MenuBar',
        name: '3D und Materialien',
    },
    {
        id: 2164261400,
        label: 'Fenster > Bildnachzeichner',
        placement: 'MenuBar',
        name: 'Bildnachzeichner',
    },
    {
        id: 2164261402,
        label: 'Objekt > Bildnachzeichner > Erstellen',
        placement: 'MenuBar',
        name: 'Erstellen',
    },
    {
        id: 2164261403,
        label: 'Objekt > Bildnachzeichner > Erstellen und umwandeln',
        placement: 'MenuBar',
        name: 'Erstellen und umwandeln',
    },
    {
        id: 2164261404,
        label: 'Objekt > Bildnachzeichner > Zurückwandeln',
        placement: 'MenuBar',
        name: 'Zurückwandeln',
    },
    {
        id: 2164261406,
        label: 'Objekt > Bildnachzeichner > Umwandeln',
        placement: 'MenuBar',
        name: 'Umwandeln',
    },
    {
        id: 2164261407,
        label: 'Fenster > CSS-Eigenschaften (veraltet)',
        placement: 'MenuBar',
        name: 'CSS-Eigenschaften (veraltet)',
    },
    {
        id: 2164261409,
        label: 'Effekt > Pfad > Kontur nachzeichnen',
        placement: 'MenuBar',
        name: 'Kontur nachzeichnen',
    },
    {
        id: 2164261410,
        label: 'Bearbeiten > Adobe PDF-Vorgaben...',
        placement: 'MenuBar',
        name: 'Adobe PDF-Vorgaben...',
    },
    {
        id: 2164261411,
        label: 'Fenster > Export von Element',
        placement: 'MenuBar',
        name: 'Export von Element',
    },
    {
        id: 2164261412,
        label: 'Effekt > Videofilter > NTSC-Farben',
        placement: 'MenuBar',
        name: 'NTSC-Farben',
    },
    {
        id: 2164261414,
        label: 'Effekt > Kunstfilter > Aquarell...',
        placement: 'MenuBar',
        name: 'Aquarell...',
    },
    {
        id: 2164261416,
        label: 'Effekt > Zeichenfilter > Feuchtes Papier...',
        placement: 'MenuBar',
        name: 'Feuchtes Papier...',
    },
    {
        id: 2164261417,
        label: 'Effekt > Kunstfilter > Malgrund...',
        placement: 'MenuBar',
        name: 'Malgrund...',
    },
    {
        id: 2164261418,
        label: 'Effekt > Zeichenfilter > Gerissene Kanten...',
        placement: 'MenuBar',
        name: 'Gerissene Kanten...',
    },
    {
        id: 2164261420,
        label: 'Effekt > Strukturierungsfilter > Mit Struktur versehen...',
        placement: 'MenuBar',
        name: 'Mit Struktur versehen...',
    },
    {
        id: 2164261422,
        label: 'Effekt > Malfilter > Sumi-e...',
        placement: 'MenuBar',
        name: 'Sumi-e...',
    },
    {
        id: 2164261423,
        label: 'Effekt > Zeichenfilter > Stempel...',
        placement: 'MenuBar',
        name: 'Stempel...',
    },
    {
        id: 2164261424,
        label: 'Effekt > Strukturierungsfilter > Buntglas-Mosaik...',
        placement: 'MenuBar',
        name: 'Buntglas-Mosaik...',
    },
    {
        id: 2164261425,
        label: 'Effekt > Malfilter > Verwackelte Striche...',
        placement: 'MenuBar',
        name: 'Verwackelte Striche...',
    },
    {
        id: 2164261426,
        label: 'Effekt > Kunstfilter > Schwamm...',
        placement: 'MenuBar',
        name: 'Schwamm...',
    },
    {
        id: 2164261427,
        label: 'Effekt > Malfilter > Spritzer...',
        placement: 'MenuBar',
        name: 'Spritzer...',
    },
    {
        id: 2164261428,
        label: 'Effekt > Kunstfilter > Diagonal verwischen...',
        placement: 'MenuBar',
        name: 'Diagonal verwischen...',
    },
    {
        id: 2164261429,
        label: 'Effekt > Kunstfilter > Grobes Pastell...',
        placement: 'MenuBar',
        name: 'Grobes Pastell...',
    },
    {
        id: 2164261430,
        label: 'Effekt > Zeichenfilter > Punktierstich...',
        placement: 'MenuBar',
        name: 'Punktierstich...',
    },
    {
        id: 2164261431,
        label: 'Effekt > Kunstfilter > Tontrennung & Kantenbetonung...',
        placement: 'MenuBar',
        name: 'Tontrennung & Kantenbetonung...',
    },
    {
        id: 2164261432,
        label: 'Effekt > Kunstfilter > Kunststofffolie...',
        placement: 'MenuBar',
        name: 'Kunststofffolie...',
    },
    {
        id: 2164261433,
        label: 'Effekt > Zeichenfilter > Stuck...',
        placement: 'MenuBar',
        name: 'Stuck...',
    },
    {
        id: 2164261434,
        label: 'Effekt > Zeichenfilter > Fotokopie...',
        placement: 'MenuBar',
        name: 'Fotokopie...',
    },
    {
        id: 2164261435,
        label: 'Effekt > Strukturierungsfilter > Patchwork...',
        placement: 'MenuBar',
        name: 'Patchwork...',
    },
    {
        id: 2164261436,
        label: 'Effekt > Kunstfilter > Malmesser...',
        placement: 'MenuBar',
        name: 'Malmesser...',
    },
    {
        id: 2164261437,
        label: 'Effekt > Kunstfilter > Ölfarbe getupft...',
        placement: 'MenuBar',
        name: 'Ölfarbe getupft...',
    },
    {
        id: 2164261439,
        label: 'Effekt > Verzerrungsfilter > Ozeanwellen...',
        placement: 'MenuBar',
        name: 'Ozeanwellen...',
    },
    {
        id: 2164261440,
        label: 'Effekt > Zeichenfilter > Prägepapier...',
        placement: 'MenuBar',
        name: 'Prägepapier...',
    },
    {
        id: 2164261441,
        label: 'Effekt > Kunstfilter > Neonschein...',
        placement: 'MenuBar',
        name: 'Neonschein...',
    },
    {
        id: 2164261442,
        label: 'Effekt > Strukturierungsfilter > Kacheln...',
        placement: 'MenuBar',
        name: 'Kacheln...',
    },
    {
        id: 2164261443,
        label: 'Effekt > Malfilter > Konturen mit Tinte nachzeichnen...',
        placement: 'MenuBar',
        name: 'Konturen mit Tinte nachzeichnen...',
    },
    {
        id: 2164261444,
        label: 'Effekt > Zeichenfilter > Rasterungseffekt...',
        placement: 'MenuBar',
        name: 'Rasterungseffekt...',
    },
    {
        id: 2164261445,
        label: 'Effekt > Zeichenfilter > Strichumsetzung...',
        placement: 'MenuBar',
        name: 'Strichumsetzung...',
    },
    {
        id: 2164261446,
        label: 'Effekt > Strukturierungsfilter > Körnung...',
        placement: 'MenuBar',
        name: 'Körnung...',
    },
    {
        id: 2164261448,
        label: 'Effekt > Stilisierungsfilter > Leuchtende Konturen...',
        placement: 'MenuBar',
        name: 'Leuchtende Konturen...',
    },
    {
        id: 2164261449,
        label: 'Effekt > Verzerrungsfilter > Glas...',
        placement: 'MenuBar',
        name: 'Glas...',
    },
    {
        id: 2164261450,
        label: 'Effekt > Kunstfilter > Fresko...',
        placement: 'MenuBar',
        name: 'Fresko...',
    },
    {
        id: 2164261451,
        label: 'Effekt > Kunstfilter > Körnung & Aufhellung...',
        placement: 'MenuBar',
        name: 'Körnung & Aufhellung...',
    },
    {
        id: 2164261452,
        label: 'Effekt > Kunstfilter > Grobe Malerei...',
        placement: 'MenuBar',
        name: 'Grobe Malerei...',
    },
    {
        id: 2164261453,
        label: 'Effekt > Verzerrungsfilter > Weiches Licht...',
        placement: 'MenuBar',
        name: 'Weiches Licht...',
    },
    {
        id: 2164261454,
        label: 'Effekt > Malfilter > Dunkle Malstriche...',
        placement: 'MenuBar',
        name: 'Dunkle Malstriche...',
    },
    {
        id: 2164261455,
        label: 'Effekt > Kunstfilter > Farbpapier-Collage...',
        placement: 'MenuBar',
        name: 'Farbpapier-Collage...',
    },
    {
        id: 2164261456,
        label: 'Effekt > Malfilter > Kreuzschraffur...',
        placement: 'MenuBar',
        name: 'Kreuzschraffur...',
    },
    {
        id: 2164261457,
        label: 'Effekt > Strukturierungsfilter > Risse...',
        placement: 'MenuBar',
        name: 'Risse...',
    },
    {
        id: 2164261458,
        label: 'Effekt > Zeichenfilter > Conté-Stifte...',
        placement: 'MenuBar',
        name: 'Conté-Stifte...',
    },
    {
        id: 2164261459,
        label: 'Effekt > Kunstfilter > Buntstiftschraffur...',
        placement: 'MenuBar',
        name: 'Buntstiftschraffur...',
    },
    {
        id: 2164261460,
        label: 'Effekt > Zeichenfilter > Chrom...',
        placement: 'MenuBar',
        name: 'Chrom...',
    },
    {
        id: 2164261461,
        label: 'Effekt > Zeichenfilter > Kohleumsetzung...',
        placement: 'MenuBar',
        name: 'Kohleumsetzung...',
    },
    {
        id: 2164261462,
        label: 'Effekt > Zeichenfilter > Kreide & Kohle...',
        placement: 'MenuBar',
        name: 'Kreide & Kohle...',
    },
    {
        id: 2164261463,
        label: 'Effekt > Zeichenfilter > Basrelief...',
        placement: 'MenuBar',
        name: 'Basrelief...',
    },
    {
        id: 2164261464,
        label: 'Effekt > Malfilter > Gekreuzte Malstriche...',
        placement: 'MenuBar',
        name: 'Gekreuzte Malstriche...',
    },
    {
        id: 2164261465,
        label: 'Effekt > Malfilter > Kanten betonen...',
        placement: 'MenuBar',
        name: 'Kanten betonen...',
    },
    {
        id: 2164261466,
        label: 'Effekt > Effekte-Galerie...',
        placement: 'MenuBar',
        name: 'Effekte-Galerie...',
    },
    {
        id: 2164261468,
        label: 'Effekt > Verzerrungs- und Transformationsfilter > Transformieren...',
        placement: 'MenuBar',
        name: 'Transformieren...',
    },
    {
        id: 2164261470,
        label: 'Effekt > Stilisierungsfilter > Schlagschatten...',
        placement: 'MenuBar',
        name: 'Schlagschatten...',
    },
    {
        id: 2164261471,
        label: 'Effekt > Stilisierungsfilter > Schein nach außen...',
        placement: 'MenuBar',
        name: 'Schein nach außen...',
    },
    {
        id: 2164261472,
        label: 'Effekt > Stilisierungsfilter > Schein nach innen...',
        placement: 'MenuBar',
        name: 'Schein nach innen...',
    },
    {
        id: 2164261474,
        label: 'Effekt > In Form umwandeln > Rechteck...',
        placement: 'MenuBar',
        name: 'Rechteck...',
    },
    {
        id: 2164261475,
        label: 'Effekt > In Form umwandeln > Abgerundetes Rechteck...',
        placement: 'MenuBar',
        name: 'Abgerundetes Rechteck...',
    },
    {
        id: 2164261476,
        label: 'Effekt > In Form umwandeln > Ellipse...',
        placement: 'MenuBar',
        name: 'Ellipse...',
    },
    {
        id: 2164261477,
        label: 'Effekt > Stilisierungsfilter > Ecken abrunden...',
        placement: 'MenuBar',
        name: 'Ecken abrunden...',
    },
    {
        id: 2164261478,
        label: 'Effekt > Verzerrungs- und Transformationsfilter > Frei verzerren...',
        placement: 'MenuBar',
        name: 'Frei verzerren...',
    },
    {
        id: 2164261479,
        label: 'Effekt > Verzerrungs- und Transformationsfilter > Zusammenziehen und aufblasen...',
        placement: 'MenuBar',
        name: 'Zusammenziehen und aufblasen...',
    },
    {
        id: 2164261480,
        label: 'Effekt > Verzerrungs- und Transformationsfilter > Tweak...',
        placement: 'MenuBar',
        name: 'Tweak...',
    },
    {
        id: 2164261481,
        label: 'Effekt > Verzerrungs- und Transformationsfilter > Aufrauen...',
        placement: 'MenuBar',
        name: 'Aufrauen...',
    },
    {
        id: 2164261482,
        label: 'Effekt > Verzerrungs- und Transformationsfilter > Zickzack...',
        placement: 'MenuBar',
        name: 'Zickzack...',
    },
    {
        id: 2164261483,
        label: 'Effekt > Stilisierungsfilter > Scribble...',
        placement: 'MenuBar',
        name: 'Scribble...',
    },
    {
        id: 2164261485,
        label: 'Effekt > Verkrümmungsfilter > Bogen...',
        placement: 'MenuBar',
        name: 'Bogen...',
    },
    {
        id: 2164261486,
        label: 'Effekt > Verkrümmungsfilter > Bogen unten...',
        placement: 'MenuBar',
        name: 'Bogen unten...',
    },
    {
        id: 2164261487,
        label: 'Effekt > Verkrümmungsfilter > Bogen oben...',
        placement: 'MenuBar',
        name: 'Bogen oben...',
    },
    {
        id: 2164261488,
        label: 'Effekt > Verkrümmungsfilter > Torbogen...',
        placement: 'MenuBar',
        name: 'Torbogen...',
    },
    {
        id: 2164261489,
        label: 'Effekt > Verkrümmungsfilter > Wulst...',
        placement: 'MenuBar',
        name: 'Wulst...',
    },
    {
        id: 2164261490,
        label: 'Effekt > Verkrümmungsfilter > Muschel unten...',
        placement: 'MenuBar',
        name: 'Muschel unten...',
    },
    {
        id: 2164261491,
        label: 'Effekt > Verkrümmungsfilter > Muschel oben...',
        placement: 'MenuBar',
        name: 'Muschel oben...',
    },
    {
        id: 2164261492,
        label: 'Effekt > Verkrümmungsfilter > Flagge...',
        placement: 'MenuBar',
        name: 'Flagge...',
    },
    {
        id: 2164261493,
        label: 'Effekt > Verkrümmungsfilter > Schwingungen...',
        placement: 'MenuBar',
        name: 'Schwingungen...',
    },
    {
        id: 2164261494,
        label: 'Effekt > Verkrümmungsfilter > Fisch...',
        placement: 'MenuBar',
        name: 'Fisch...',
    },
    {
        id: 2164261495,
        label: 'Effekt > Verkrümmungsfilter > Ansteigend...',
        placement: 'MenuBar',
        name: 'Ansteigend...',
    },
    {
        id: 2164261496,
        label: 'Effekt > Verkrümmungsfilter > Fischauge...',
        placement: 'MenuBar',
        name: 'Fischauge...',
    },
    {
        id: 2164261497,
        label: 'Effekt > Verkrümmungsfilter > Aufblasen...',
        placement: 'MenuBar',
        name: 'Aufblasen...',
    },
    {
        id: 2164261498,
        label: 'Effekt > Verkrümmungsfilter > Stauchen...',
        placement: 'MenuBar',
        name: 'Stauchen...',
    },
    {
        id: 2164261499,
        label: 'Effekt > Verkrümmungsfilter > Wirbel...',
        placement: 'MenuBar',
        name: 'Wirbel...',
    },
    {
        id: 2164261500,
        label: 'Effekt > In Pixelbild umwandeln...',
        placement: 'MenuBar',
        name: 'In Pixelbild umwandeln...',
    },
    {
        id: 2164261502,
        label: 'Effekt > SVG-Filter > SVG-Filter anwenden...',
        placement: 'MenuBar',
        name: 'SVG-Filter anwenden...',
    },
    {
        id: 2164261503,
        label: 'Effekt > Stilisierungsfilter > Weiche Kante...',
        placement: 'MenuBar',
        name: 'Weiche Kante...',
    },
    {
        id: 2164261504,
        label: 'Effekt > Verzerrungs- und Transformationsfilter > Wirbel...',
        placement: 'MenuBar',
        name: 'Wirbel...',
    },
    {
        id: 2164261505,
        label: 'Effekt > Pfad > Konturlinie',
        placement: 'MenuBar',
        name: 'Konturlinie',
    },
    {
        id: 2164261506,
        label: 'Effekt > Pfad > Pfad verschieben...',
        placement: 'MenuBar',
        name: 'Pfad verschieben...',
    },
    {
        id: 2164261507,
        label: 'Effekt > Weichzeichnungsfilter > Gaußscher Weichzeichner...',
        placement: 'MenuBar',
        name: 'Gaußscher Weichzeichner...',
    },
    {
        id: 2164261508,
        label: 'Bearbeiten > Eigenes Wörterbuch bearbeiten...',
        placement: 'MenuBar',
        name: 'Eigenes Wörterbuch bearbeiten...',
    },
    {
        id: 2164261511,
        label: 'Objekt > Pfad > In Raster teilen...',
        placement: 'MenuBar',
        name: 'In Raster teilen...',
    },
    {
        id: 2164261513,
        label: 'Schrift > Groß-/Kleinschreibung ändern > GROSSBUCHSTABEN',
        placement: 'MenuBar',
        name: 'GROSSBUCHSTABEN',
    },
    {
        id: 2164261514,
        label: 'Schrift > Groß-/Kleinschreibung ändern > kleinbuchstaben',
        placement: 'MenuBar',
        name: 'kleinbuchstaben',
    },
    {
        id: 2164261515,
        label: 'Schrift > Groß-/Kleinschreibung ändern > Erster Buchstabe Im Wort Groß',
        placement: 'MenuBar',
        name: 'Erster Buchstabe Im Wort Groß',
    },
    {
        id: 2164261516,
        label: 'Schrift > Groß-/Kleinschreibung ändern > Erster buchstabe im satz groß',
        placement: 'MenuBar',
        name: 'Erster buchstabe im satz groß',
    },
    {
        id: 2164261517,
        label: 'Schrift > Optischer Randausgleich',
        placement: 'MenuBar',
        name: 'Optischer Randausgleich',
    },
    {
        id: 2164261518,
        label: 'Schrift > Schriftart suchen/ersetzen…',
        placement: 'MenuBar',
        name: 'Schriftart suchen/ersetzen…',
    },
    {
        id: 2164261519,
        label: 'Schrift > Satz-/Sonderzeichen...',
        placement: 'MenuBar',
        name: 'Satz-/Sonderzeichen...',
    },
    {
        id: 2164261520,
        label: 'Objekt > Transformieren > Einzeln transformieren...',
        placement: 'MenuBar',
        name: 'Einzeln transformieren...',
    },
    {
        id: 2164261521,
        label: 'Objekt > Verlaufsgitter erstellen...',
        placement: 'MenuBar',
        name: 'Verlaufsgitter erstellen...',
    },
    {
        id: 2164261522,
        label: 'Auswahl > Auswahl umkehren',
        placement: 'MenuBar',
        name: 'Auswahl umkehren',
    },
    {
        id: 2164261524,
        label: 'Objekt > Pfad > Aufräumen...',
        placement: 'MenuBar',
        name: 'Aufräumen...',
    },
    {
        id: 2164261525,
        label: 'Bearbeiten > Farben bearbeiten > Schwarz überdrucken...',
        placement: 'MenuBar',
        name: 'Schwarz überdrucken...',
    },
    {
        id: 2164261527,
        label: 'Objekt > Textumfluss > Erstellen',
        placement: 'MenuBar',
        name: 'Erstellen',
    },
    {
        id: 2164261528,
        label: 'Objekt > Textumfluss > Zurückwandeln',
        placement: 'MenuBar',
        name: 'Zurückwandeln',
    },
    {
        id: 2164261530,
        label: 'Objekt > Textumfluss > Textumflussoptionen…',
        placement: 'MenuBar',
        name: 'Textumflussoptionen…',
    },
    {
        id: 2164261531,
        label: 'Auswahl > Objekt > Schnittmasken',
        placement: 'MenuBar',
        name: 'Schnittmasken',
    },
    {
        id: 2164261532,
        label: 'Bearbeiten > Farben bearbeiten > Sättigung erhöhen...',
        placement: 'MenuBar',
        name: 'Sättigung erhöhen...',
    },
    {
        id: 2164261534,
        label: 'Objekt > Pfad > Ankerpunkte hinzufügen',
        placement: 'MenuBar',
        name: 'Ankerpunkte hinzufügen',
    },
    {
        id: 2164261535,
        label: 'Bearbeiten > Farben bearbeiten > Farbbalance einstellen...',
        placement: 'MenuBar',
        name: 'Farbbalance einstellen...',
    },
    {
        id: 2164261536,
        label: 'Objekt > Objektmosaik erstellen...',
        placement: 'MenuBar',
        name: 'Objektmosaik erstellen...',
    },
    {
        id: 2164261537,
        label: 'Datei > Verpacken...',
        placement: 'MenuBar',
        name: 'Verpacken...',
    },
    {
        id: 2164261538,
        label: 'Datei > Bridge durchsuchen...',
        placement: 'MenuBar',
        name: 'Bridge durchsuchen...',
    },
    {
        id: 2164261539,
        label: 'Datei > Dateiinformationen...',
        placement: 'MenuBar',
        name: 'Dateiinformationen...',
    },
    {
        id: 2164261541,
        label: 'Objekt > Verzerrungshülle > Mit Verkrümmung erstellen...',
        placement: 'MenuBar',
        name: 'Mit Verkrümmung erstellen...',
    },
    {
        id: 2164261542,
        label: 'Objekt > Verzerrungshülle > Mit Gitter erstellen...',
        placement: 'MenuBar',
        name: 'Mit Gitter erstellen...',
    },
    {
        id: 2164261543,
        label: 'Objekt > Verzerrungshülle > Mit oberstem Objekt erstellen',
        placement: 'MenuBar',
        name: 'Mit oberstem Objekt erstellen',
    },
    {
        id: 2164261544,
        label: 'Objekt > Verzerrungshülle > Zurückwandeln',
        placement: 'MenuBar',
        name: 'Zurückwandeln',
    },
    {
        id: 2164261546,
        label: 'Objekt > Verzerrungshülle > Hüllen-Optionen...',
        placement: 'MenuBar',
        name: 'Hüllen-Optionen...',
    },
    {
        id: 2164261548,
        label: 'Objekt > Verzerrungshülle > Umwandeln',
        placement: 'MenuBar',
        name: 'Umwandeln',
    },
    {
        id: 2164261550,
        label: 'Objekt > Verzerrungshülle > Inhalt bearbeiten',
        placement: 'MenuBar',
        name: 'Inhalt bearbeiten',
    },
    {
        id: 2164261552,
        label: 'Bearbeiten > Rechtschreibung > Automatische Rechtschreibprüfung',
        placement: 'MenuBar',
        name: 'Automatische Rechtschreibprüfung',
    },
    {
        id: 2164261553,
        label: 'Bearbeiten > Rechtschreibung > Rechtschreibprüfung...',
        placement: 'MenuBar',
        name: 'Rechtschreibprüfung...',
    },
    {
        id: 2164261554,
        label: 'Auswahl > Globale Bearbeitung starten',
        placement: 'MenuBar',
        name: 'Globale Bearbeitung starten',
    },
    {
        id: 2164261555,
        label: 'Bearbeiten > Suchen und ersetzen...',
        placement: 'MenuBar',
        name: 'Suchen und ersetzen...',
    },
    {
        id: 2164261556,
        label: 'Bearbeiten > Weitersuchen',
        placement: 'MenuBar',
        name: 'Weitersuchen',
    },
    {
        id: 2164261558,
        label: 'Effekt > Dokument-Rastereffekt-Einstellungen...',
        placement: 'MenuBar',
        name: 'Dokument-Rastereffekt-Einstellungen...',
    },
    {
        id: 2164261559,
        label: 'Objekt > In Pixelbild umwandeln...',
        placement: 'MenuBar',
        name: 'In Pixelbild umwandeln...',
    },
    {
        id: 2164261560,
        label: 'Datei > Ausgewählte Slices speichern...',
        placement: 'MenuBar',
        name: 'Ausgewählte Slices speichern...',
    },
    {
        id: 2164261561,
        label: 'Effekt > SVG-Filter > SVG-Filter importieren...',
        placement: 'MenuBar',
        name: 'SVG-Filter importieren...',
    },
    {
        id: 2164261563,
        label: 'Objekt > Bild zuschneiden',
        placement: 'MenuBar',
        name: 'Bild zuschneiden',
    },
    {
        id: 2164261564,
        label: 'Objekt > Anordnen > In aktuelle Ebene verschieben',
        placement: 'MenuBar',
        name: 'In aktuelle Ebene verschieben',
    },
    {
        id: 2164261566,
        label: 'Objekt > Sperren > Sämtliches Bildmaterial darüber',
        placement: 'MenuBar',
        name: 'Sämtliches Bildmaterial darüber',
    },
    {
        id: 2164261567,
        label: 'Objekt > Sperren > Andere Ebenen',
        placement: 'MenuBar',
        name: 'Andere Ebenen',
    },
    {
        id: 2164261568,
        label: 'Objekt > Ausblenden > Sämtliches Bildmaterial darüber',
        placement: 'MenuBar',
        name: 'Sämtliches Bildmaterial darüber',
    },
    {
        id: 2164261569,
        label: 'Objekt > Ausblenden > Andere Ebenen',
        placement: 'MenuBar',
        name: 'Andere Ebenen',
    },
    {
        id: 2164261570,
        label: 'Auswahl > Objekt > Alles auf denselben Ebenen',
        placement: 'MenuBar',
        name: 'Alles auf denselben Ebenen',
    },
    {
        id: 2164261571,
        label: 'Auswahl > Objekt > Richtungsgriffe',
        placement: 'MenuBar',
        name: 'Richtungsgriffe',
    },
    {
        id: 2164261574,
        label: 'Auswahl > Nächstes Objekt darüber',
        placement: 'MenuBar',
        name: 'Nächstes Objekt darüber',
    },
    {
        id: 2164261575,
        label: 'Auswahl > Nächstes Objekt darunter',
        placement: 'MenuBar',
        name: 'Nächstes Objekt darunter',
    },
    {
        id: 2164261578,
        label: 'Auswahl > Auswahl speichern...',
        placement: 'MenuBar',
        name: 'Auswahl speichern...',
    },
    {
        id: 2164261579,
        label: 'Auswahl > Auswahl bearbeiten...',
        placement: 'MenuBar',
        name: 'Auswahl bearbeiten...',
    },
    {
        id: 2164261580,
        label: 'Auswahl > Auswahl aktualisieren',
        placement: 'MenuBar',
        name: 'Auswahl aktualisieren',
    },
    {
        id: 2164261584,
        label: 'Datei > Skripten > Anderes Skript...',
        placement: 'MenuBar',
        name: 'Anderes Skript...',
    },
    {
        id: 2164261585,
        label: 'Ansicht > Ecken-Widget ausblenden',
        placement: 'MenuBar',
        name: 'Ecken-Widget ausblenden',
    },
    {
        id: 2164261586,
        label: 'Objekt > Pfad > Konturlinie',
        placement: 'MenuBar',
        name: 'Konturlinie',
    },
    {
        id: 2164261587,
        label: 'Objekt > Pfad > Pfad verschieben...',
        placement: 'MenuBar',
        name: 'Pfad verschieben...',
    },
    {
        id: 2164261588,
        label: 'Bearbeiten > Druckvorgaben...',
        placement: 'MenuBar',
        name: 'Druckvorgaben...',
    },
    {
        id: 2164261589,
        label: 'Datei > Drucken...',
        placement: 'MenuBar',
        name: 'Drucken...',
    },
    {
        id: 2164261591,
        label: 'Objekt > Perspektive > Aktiver Ebene anhängen',
        placement: 'MenuBar',
        name: 'Aktiver Ebene anhängen',
    },
    {
        id: 2164261592,
        label: 'Objekt > Perspektive > Aus Perspektive freigeben',
        placement: 'MenuBar',
        name: 'Aus Perspektive freigeben',
    },
    {
        id: 2164261593,
        label: 'Objekt > Perspektive > Ebene an Objekt ausrichten',
        placement: 'MenuBar',
        name: 'Ebene an Objekt ausrichten',
    },
    {
        id: 2164261594,
        label: 'Objekt > Perspektive > Text bearbeiten',
        placement: 'MenuBar',
        name: 'Text bearbeiten',
    },
    {
        id: 2164261595,
        label: 'Bearbeiten > Vorgaben für Perspektivenraster...',
        placement: 'MenuBar',
        name: 'Vorgaben für Perspektivenraster...',
    },
    {
        id: 2164261598,
        label: 'Ansicht > Perspektivenraster > Raster einblenden',
        placement: 'MenuBar',
        name: 'Raster einblenden',
    },
    {
        id: 2164261599,
        label: 'Ansicht > Perspektivenraster > Lineale einblenden',
        placement: 'MenuBar',
        name: 'Lineale einblenden',
    },
    {
        id: 2164261600,
        label: 'Ansicht > Perspektivenraster > Am Raster ausrichten',
        placement: 'MenuBar',
        name: 'Am Raster ausrichten',
    },
    {
        id: 2164261601,
        label: 'Ansicht > Perspektivenraster > Raster sperren',
        placement: 'MenuBar',
        name: 'Raster sperren',
    },
    {
        id: 2164261602,
        label: 'Ansicht > Perspektivenraster > Bezugspunkt sperren',
        placement: 'MenuBar',
        name: 'Bezugspunkt sperren',
    },
    {
        id: 2164261604,
        label: 'Ansicht > Perspektivenraster > Raster definieren...',
        placement: 'MenuBar',
        name: 'Raster definieren...',
    },
    {
        id: 2164261610,
        label: 'Ansicht > Perspektivenraster > Raster als Vorgabe speichern...',
        placement: 'MenuBar',
        name: 'Raster als Vorgabe speichern...',
    },
    {
        id: 2164261611,
        label: 'Datei > Zum Bearbeiten einladen...',
        placement: 'MenuBar',
        name: 'Zum Bearbeiten einladen...',
    },
    {
        id: 2164261612,
        label: 'Datei > Für Review freigeben…',
        placement: 'MenuBar',
        name: 'Für Review freigeben…',
    },
    {
        id: 2164261615,
        label: 'Fenster > Erweiterungen > Bibliotheken',
        placement: 'MenuBar',
        name: 'Bibliotheken',
    },
    {
        id: 2164261616,
        label: 'Fenster > Versionsverlauf',
        placement: 'MenuBar',
        name: 'Versionsverlauf',
    },
    {
        id: 2164261617,
        label: 'Datei > Versionsverlauf',
        placement: 'MenuBar',
        name: 'Versionsverlauf',
    },
    {
        id: 2164261618,
        label: 'Fenster > Kommentare',
        placement: 'MenuBar',
        name: 'Kommentare',
    },
    {
        id: 'Adobe Scroll Tool',
        label: 'Hand-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pen Tool',
        label: 'Zeichenstift-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scale Tool',
        label: 'Skalieren-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Tool',
        label: 'Drehen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reflect Tool',
        label: 'Spiegeln-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shear Tool',
        label: 'Verbiegen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scissors Tool',
        label: 'Schere-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Measure Tool',
        label: 'Mess-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Page Tool',
        label: 'Druckaufteilungswerkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Object Select Tool',
        label: 'Gruppenauswahl-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Select Tool',
        label: 'Direktauswahl-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Select Tool',
        label: 'Auswahl-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Zoom Tool',
        label: 'Zoomwerkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Add Anchor Point Tool',
        label: 'Ankerpunkt-hinzufügen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Delete Anchor Point Tool',
        label: 'Ankerpunkt-löschen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Anchor Point Tool',
        label: 'Ankerpunkt-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Column Graph Tool',
        label: 'Vertikales Balkendiagramm',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Column Graph Tool',
        label: 'Gestapeltes vertikales Balkendiagramm',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Graph Tool',
        label: 'Liniendiagramm',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pie Graph Tool',
        label: 'Kreisdiagramm',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Graph Tool',
        label: 'Flächendiagramm',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scatter Graph Tool',
        label: 'Streudiagramm',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bar Graph Tool',
        label: 'Horizontales Balkendiagramm',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Bar Graph Tool',
        label: 'Gestapeltes horizontales Balkendiagramm',
        placement: 'Tool',
    },
    {
        id: 'Adobe Radar Graph Tool',
        label: 'Netzdiagramm',
        placement: 'Tool',
    },
    {
        id: 'Adobe Type Tool',
        label: 'Text-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Type Tool',
        label: 'Flächentext-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Path Type Tool',
        label: 'Pfadtext-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Type Tool',
        label: 'Vertikaler-Text-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Area Type Tool',
        label: 'Vertikaler-Flächentext-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Path Type Tool',
        label: 'Vertikaler-Pfadtext-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Touch Type Tool',
        label: 'Touch-Type-Textwerkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Builder Tool',
        label: 'Formerstellungswerkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Paintbucket Tool',
        label: 'Interaktiv-malen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Face Select Tool',
        label: 'Interaktiv-malen-Auswahlwerkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Dimension Tool',
        label: 'Bemaßungswerkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Gradient Vector Tool',
        label: 'Verlaufwerkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blend Tool',
        label: 'Angleichen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Tool',
        label: 'Slice-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Select Tool',
        label: 'Slice-Auswahl-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Perspective Grid Tool',
        label: 'Perspektivenraster-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Perspective Selection Tool',
        label: 'Perspektivenauswahl-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Curvature Tool',
        label: 'Kurvenzeichner',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Lasso Tool',
        label: 'Lasso-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Crop Tool',
        label: 'Zeichenflächenwerkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reshape Tool',
        label: 'Form-ändern-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Width Tool',
        label: 'Breiten-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shaper Tool',
        label: 'Shaper-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Puppet Warp Tool',
        label: 'Formgitter-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Magic Wand Tool',
        label: 'Zauberstab-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Knife Tool',
        label: 'Messer-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Free Transform Tool',
        label: 'Frei-transformieren-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eraser Tool',
        label: 'Radiergummi-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Warp Tool',
        label: 'Verkrümmen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe New Twirl Tool',
        label: 'Strudel-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pucker Tool',
        label: 'Zusammenziehen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bloat Tool',
        label: 'Aufblasen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scallop Tool',
        label: 'Ausbuchten-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Cyrstallize Tool',
        label: 'Kristallisieren-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Wrinkle Tool',
        label: 'Zerknittern-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Quick Pen Tool',
        label: 'Schnellstift-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Constraints Tool',
        label: 'Objekte auf Pfad',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Canvas Tool',
        label: 'Ansichtdrehungs-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Tool',
        label: 'Buntstift-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Brush Tool',
        label: 'Pinsel-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blob Brush Tool',
        label: 'Tropfenpinsel-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Smooth Tool',
        label: 'Glätten-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Erase Tool',
        label: 'Löschen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Corner Join Tool',
        label: 'Zusammenfügen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eyedropper Tool',
        label: 'Pipette-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Ellipse Shape Tool',
        label: 'Ellipse-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Regular Polygon Tool',
        label: 'Polygon-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Star Tool',
        label: 'Stern-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangle Shape Tool',
        label: 'Rechteck-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rounded Rectangle Tool',
        label: 'Abgerundetes-Rechteck-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Spiral Tool',
        label: 'Spirale-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sprayer Tool',
        label: 'Symbol-aufsprühen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Shifter Tool',
        label: 'Symbol-verschieben-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Scruncher Tool',
        label: 'Symbol-stauchen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sizer Tool',
        label: 'Symbol-skalieren-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Spinner Tool',
        label: 'Symbol-drehen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Stainer Tool',
        label: 'Symbol-färben-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Screener Tool',
        label: 'Symbol-transparent-gestalten-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Styler Tool',
        label: 'Symbol-gestalten-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Mesh Editing Tool',
        label: 'Gitter-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Flare Tool',
        label: 'Blendenflecke-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Tool',
        label: 'Liniensegment-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Arc Tool',
        label: 'Bogen-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangular Grid Tool',
        label: 'Rechteckiges-Raster-Werkzeug',
        placement: 'Tool',
    },
    {
        id: 'Adobe Polar Grid Tool',
        label: 'Radiales-Raster-Werkzeug',
        placement: 'Tool',
    },
    {
        id: '3D and Materials',
        label: '3D und Materialien',
        placement: 'Panel',
    },
    {
        id: 'Actions',
        label: 'Aktionen',
        placement: 'Panel',
    },
    {
        id: 'AdobeAltGlyphsPanel',
        label: 'Glyphen',
        placement: 'Panel',
    },
    {
        id: 'AdobeBrush',
        label: 'Pinsel',
        placement: 'Panel',
    },
    {
        id: 'AdobeCharStyles',
        label: 'Zeichenformate',
        placement: 'Panel',
    },
    {
        id: 'AdobeColorGuidePanel',
        label: 'Farbhilfe',
        placement: 'Panel',
    },
    {
        id: 'AdobeFlatteningPreview',
        label: 'Reduzierungsvorschau',
        placement: 'Panel',
    },
    {
        id: 'AdobeGradientEditor',
        label: 'Verlauf',
        placement: 'Panel',
    },
    {
        id: 'AdobeHorizontalTabPanel',
        label: 'Tabulatoren',
        placement: 'Panel',
    },
    {
        id: 'AdobeLayerPalette',
        label: 'Ebenen',
        placement: 'Panel',
    },
    {
        id: 'AdobeObjectAttributes',
        label: 'Attribute',
        placement: 'Panel',
    },
    {
        id: 'AdobeOpenTypeFont',
        label: 'OpenType',
        placement: 'Panel',
    },
    {
        id: 'AdobeParaStyles',
        label: 'Absatzformate',
        placement: 'Panel',
    },
    {
        id: 'AdobePropertiesPanel',
        label: 'Eigenschaften',
        placement: 'Panel',
    },
    {
        id: 'AdobeSeparationPreview',
        label: 'Separationenvorschau',
        placement: 'Panel',
    },
    {
        id: 'AdobeSwatch_',
        label: 'Farbfelder',
        placement: 'Panel',
    },
    {
        id: 'AdobeVariablesPanel',
        label: 'Variablen',
        placement: 'Panel',
    },
    {
        id: 'AdobeVerticalTabPanel',
        label: 'Tabulatoren',
        placement: 'Panel',
    },
    {
        id: 'Align',
        label: 'Ausrichten',
        placement: 'Panel',
    },
    {
        id: 'Appearance',
        label: 'Aussehen',
        placement: 'Panel',
    },
    {
        id: 'Artboards',
        label: 'Zeichenflächen',
        placement: 'Panel',
    },
    {
        id: 'CCX Commenting UXP Webview',
        label: 'Kommentare',
        placement: 'Panel',
    },
    {
        id: 'CSS',
        label: 'CSS-Eigenschaften (veraltet)',
        placement: 'Panel',
    },
    {
        id: 'CSXSExtension_com.adobe.DesignLibraries.angular_0',
        label: 'Bibliotheken',
        placement: 'Panel',
    },
    {
        id: 'Character',
        label: 'Zeichen',
        placement: 'Panel',
    },
    {
        id: 'Color',
        label: 'Farbe',
        placement: 'Panel',
    },
    {
        id: 'Document Info',
        label: 'Dokumentinformationen',
        placement: 'Panel',
    },
    {
        id: 'Export',
        label: 'Export von Element',
        placement: 'Panel',
    },
    {
        id: 'GeneratedVariations',
        label: 'Generierte Variationen',
        placement: 'Panel',
    },
    {
        id: 'History',
        label: 'Protokoll',
        placement: 'Panel',
    },
    {
        id: 'Info',
        label: 'Info',
        placement: 'Panel',
    },
    {
        id: 'Links',
        label: 'Verknüpfungen',
        placement: 'Panel',
    },
    {
        id: 'Magic Wand',
        label: 'Zauberstab',
        placement: 'Panel',
    },
    {
        id: 'Mockup',
        label: 'Modell',
        placement: 'Panel',
    },
    {
        id: 'NamedStyle',
        label: 'Grafikstile',
        placement: 'Panel',
    },
    {
        id: 'Navigator',
        label: 'Navigator',
        placement: 'Panel',
    },
    {
        id: 'Paragraph',
        label: 'Absatz',
        placement: 'Panel',
    },
    {
        id: 'Pathfinder',
        label: 'Pathfinder',
        placement: 'Panel',
    },
    {
        id: 'PatternOptionsPanel',
        label: 'Musteroptionen',
        placement: 'Panel',
    },
    {
        id: 'Reflow Viewer',
        label: 'Reflow-Ansicht',
        placement: 'Panel',
    },
    {
        id: 'Retype',
        label: 'Retype',
        placement: 'Panel',
    },
    {
        id: 'SVGInteractivity',
        label: 'SVG-Interaktivität',
        placement: 'Panel',
    },
    {
        id: 'Stroke',
        label: 'Kontur',
        placement: 'Panel',
    },
    {
        id: 'Symbols',
        label: 'Symbole',
        placement: 'Panel',
    },
    {
        id: 'Transform',
        label: 'Transformieren',
        placement: 'Panel',
    },
    {
        id: 'Transparency',
        label: 'Transparenz',
        placement: 'Panel',
    },
    {
        id: 'Vectorize',
        label: 'Bildnachzeichner',
        placement: 'Panel',
    },
    {
        id: 'ccx-timeline',
        label: 'Versionsverlauf',
        placement: 'Panel',
    },
];
